!(function ($) {
  var $ = (jQuery = $),
    cc = { sections: [] };
  (theme.cartNoteMonitor = {
    load: function e(t) {
      t.on(
        "change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor",
        function () {
          theme.cartNoteMonitor.postUpdate($(this).val());
        }
      );
    },
    unload: function e(t) {
      t.off(".themeCartNoteMonitor");
    },
    updateThrottleTimeoutId: -1,
    updateThrottleInterval: 500,
    postUpdate: function e(t) {
      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId),
        (theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(
          function () {
            $.post(
              theme.routes.cart_url + "/update.js",
              { note: t },
              function (e) {},
              "json"
            );
          },
          theme.cartNoteMonitor.updateThrottleInterval
        ));
    },
  }),
    (theme.Shopify = {
      formatMoney: function e(t, i) {
        function a(e, t) {
          return void 0 === e ? t : e;
        }
        function o(e, t, i, o) {
          if (
            ((t = a(t, 2)),
            (i = a(i, ",")),
            (o = a(o, ".")),
            isNaN(e) || null == e)
          )
            return 0;
          var n = (e = (e / 100).toFixed(t)).split(".");
          return (
            n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
            (n[1] ? o + n[1] : "")
          );
        }
        "string" == typeof t && (t = t.replace(".", ""));
        var n = "",
          s = /\{\{\s*(\w+)\s*\}\}/,
          r = i || this.money_format;
        switch (r.match(s)[1]) {
          case "amount":
            n = o(t, 2);
            break;
          case "amount_no_decimals":
            n = o(t, 0);
            break;
          case "amount_with_comma_separator":
            n = o(t, 2, ".", ",");
            break;
          case "amount_with_space_separator":
            n = o(t, 2, " ", ",");
            break;
          case "amount_with_period_and_space_separator":
            n = o(t, 2, " ", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            n = o(t, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            n = o(t, 0, " ", "");
            break;
          case "amount_with_apostrophe_separator":
            n = o(t, 2, "'", ".");
            break;
          case "amount_with_decimal_separator":
            n = o(t, 2, ".", ".");
        }
        return r.replace(s, n);
      },
      formatImage: function e(t, i) {
        return t ? t.replace(/^(.*)\.([^\.]*)$/g, "$1_" + i + ".$2") : "";
      },
      Image: {
        imageSize: function e(t) {
          var i = t.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return null !== i ? i[1] : null;
        },
        getSizedImageUrl: function e(t, i) {
          if (null == i) return t;
          if ("master" == i) return this.removeProtocol(t);
          var a = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (null != a) {
            var o = t.split(a[0]),
              n = a[0];
            return this.removeProtocol(o[0] + "_" + i + n);
          }
          return null;
        },
        removeProtocol: function e(t) {
          return t.replace(/http(s)?:/, "");
        },
      },
    }),
    (theme.Disclosure = (function () {
      var e = {
          disclosureList: "[data-disclosure-list]",
          disclosureToggle: "[data-disclosure-toggle]",
          disclosureInput: "[data-disclosure-input]",
          disclosureOptions: "[data-disclosure-option]",
        },
        t = { listVisible: "disclosure-list--visible" };
      function i(e) {
        (this.$container = e),
          (this.cache = {}),
          this._cacheSelectors(),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut();
      }
      return (
        (i.prototype = $.extend({}, i.prototype, {
          _cacheSelectors: function t() {
            this.cache = {
              $disclosureList: this.$container.find(e.disclosureList),
              $disclosureToggle: this.$container.find(e.disclosureToggle),
              $disclosureInput: this.$container.find(e.disclosureInput),
              $disclosureOptions: this.$container.find(e.disclosureOptions),
            };
          },
          _connectToggle: function e() {
            this.cache.$disclosureToggle.on(
              "click",
              function (e) {
                var i = "true" === $(e.currentTarget).attr("aria-expanded");
                $(e.currentTarget).attr("aria-expanded", !i),
                  this.cache.$disclosureList.toggleClass(t.listVisible);
              }.bind(this)
            );
          },
          _connectOptions: function e() {
            this.cache.$disclosureOptions.on(
              "click",
              function (e) {
                e.preventDefault(),
                  this._submitForm($(e.currentTarget).data("value"));
              }.bind(this)
            );
          },
          _onFocusOut: function e() {
            this.cache.$disclosureToggle.on(
              "focusout",
              function (e) {
                0 === this.$container.has(e.relatedTarget).length &&
                  this._hideList();
              }.bind(this)
            ),
              this.cache.$disclosureList.on(
                "focusout",
                function (e) {
                  var i = $(e.currentTarget).has(e.relatedTarget).length > 0;
                  this.cache.$disclosureList.hasClass(t.listVisible) &&
                    !i &&
                    this._hideList();
                }.bind(this)
              ),
              this.$container.on(
                "keyup",
                function (e) {
                  27 === e.which &&
                    (this._hideList(), this.cache.$disclosureToggle.focus());
                }.bind(this)
              ),
              (this.bodyOnClick = function (e) {
                var i = this.$container.has(e.target).length > 0;
                this.cache.$disclosureList.hasClass(t.listVisible) &&
                  !i &&
                  this._hideList();
              }.bind(this)),
              $("body").on("click", this.bodyOnClick);
          },
          _submitForm: function e(t) {
            this.cache.$disclosureInput.val(t),
              this.$container.parents("form").submit();
          },
          _hideList: function e() {
            this.cache.$disclosureList.removeClass(t.listVisible),
              this.cache.$disclosureToggle.attr("aria-expanded", !1);
          },
          unload: function e() {
            $("body").off("click", this.bodyOnClick),
              this.cache.$disclosureOptions.off(),
              this.cache.$disclosureToggle.off(),
              this.cache.$disclosureList.off(),
              this.$container.off();
          },
        })),
        i
      );
    })()),
    (function () {
      function e(e, t) {
        var i = -1,
          a = !1;
        return function () {
          clearTimeout(i),
            (i = setTimeout(e, t)),
            a ||
              (e.call(),
              (a = !0),
              setTimeout(function () {
                a = !1;
              }, t));
        };
      }
      var t = document.createEvent("Event");
      t.initEvent("throttled-scroll", !0, !0),
        window.addEventListener(
          "scroll",
          e(function () {
            window.dispatchEvent(t);
          }, 200)
        );
    })(),
    (theme.debounce = function (e) {
      var t,
        i =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 700,
        a = arguments.length > 2 ? arguments[2] : void 0;
      return function () {
        var o = this,
          n = arguments,
          s = function i() {
            (t = null), a || e.apply(o, n);
          },
          r = a && !t;
        clearTimeout(t), (t = setTimeout(s, i)), r && e.apply(o, n);
      };
    }),
    (theme.Sections = new (function () {
      var e = this;
      (e._instances = []),
        (e._deferredSectionTargets = []),
        (e._sections = []),
        (e._deferredLoadViewportExcess = 300),
        (e._deferredWatcherRunning = !1),
        (e.init = function () {
          $(document)
            .on("shopify:section:load", function (t) {
              var i = e._themeSectionTargetFromShopifySectionTarget(t.target);
              i && e.sectionLoad(i);
            })
            .on("shopify:section:unload", function (t) {
              var i = e._themeSectionTargetFromShopifySectionTarget(t.target);
              i && e.sectionUnload(i);
            })
            .on("shopify:section:reorder", function (t) {
              var i = e._themeSectionTargetFromShopifySectionTarget(t.target);
              i && e.sectionReorder(i);
            }),
            $(window).on(
              "throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader",
              e._processDeferredSections
            ),
            (e._deferredWatcherRunning = !0);
        }),
        (e.register = function (t, i, a) {
          e._sections.push({
            type: t,
            section: i,
            afterSectionLoadCallback: a ? a.afterLoad : null,
            afterSectionUnloadCallback: a ? a.afterUnload : null,
          }),
            $('[data-section-type="' + t + '"]').each(function () {
              Shopify.designMode ||
              (a && !1 === a.deferredLoad) ||
              !e._deferredWatcherRunning
                ? e.sectionLoad(this)
                : e.sectionDeferredLoad(this, a);
            });
        }),
        (e.sectionDeferredLoad = function (t, i) {
          e._deferredSectionTargets.push({
            target: t,
            deferredLoadViewportExcess:
              i && i.deferredLoadViewportExcess
                ? i.deferredLoadViewportExcess
                : e._deferredLoadViewportExcess,
          }),
            e._processDeferredSections(!0);
        }),
        (e._processDeferredSections = function (t) {
          if (e._deferredSectionTargets.length)
            for (
              var i = $(window).scrollTop(),
                a = i + $(window).height(),
                o = !0 === t ? e._deferredSectionTargets.length - 1 : 0,
                n = o;
              n < e._deferredSectionTargets.length;
              n++
            ) {
              var s = e._deferredSectionTargets[n].target,
                r = e._deferredSectionTargets[n].deferredLoadViewportExcess,
                l = $(s).offset().top - r,
                c = l > i && l < a;
              if (!c) {
                var d = l + $(s).outerHeight() + 2 * r;
                c = d > i && d < a;
              }
              (c || (l < i && d > a)) &&
                (e.sectionLoad(s), e._deferredSectionTargets.splice(n, 1), n--);
            }
          !0 !== t &&
            0 === e._deferredSectionTargets.length &&
            ((e._deferredWatcherRunning = !1),
            $(window).off(".themeSectionDeferredLoader"));
        }),
        (e.sectionLoad = function (t) {
          var t = t,
            i = e._sectionForTarget(t),
            a = !1;
          if (!1 !== (a = i.section ? i.section : i)) {
            var o = {
              target: t,
              section: a,
              $shopifySectionContainer: $(t).closest(".shopify-section"),
              thisContext: {
                functions: a.functions,
                registeredEventListeners: [],
              },
            };
            (o.thisContext.registerEventListener =
              e._registerEventListener.bind(o.thisContext)),
              e._instances.push(o),
              $(t).data("components") &&
                $(t)
                  .data("components")
                  .split(",")
                  .forEach((e) => {
                    $(document).trigger("cc:component:load", [e, t]);
                  }),
              e._callSectionWith(a, "onSectionLoad", t, o.thisContext),
              e._callSectionWith(
                a,
                "afterSectionLoadCallback",
                t,
                o.thisContext
              ),
              a.onSectionSelect &&
                o.$shopifySectionContainer.on(
                  "shopify:section:select",
                  function (t) {
                    e._callSectionWith(
                      a,
                      "onSectionSelect",
                      t.target,
                      o.thisContext
                    );
                  }
                ),
              a.onSectionDeselect &&
                o.$shopifySectionContainer.on(
                  "shopify:section:deselect",
                  function (t) {
                    e._callSectionWith(
                      a,
                      "onSectionDeselect",
                      t.target,
                      o.thisContext
                    );
                  }
                ),
              a.onBlockSelect &&
                $(t).on("shopify:block:select", function (t) {
                  e._callSectionWith(
                    a,
                    "onBlockSelect",
                    t.target,
                    o.thisContext
                  );
                }),
              a.onBlockDeselect &&
                $(t).on("shopify:block:deselect", function (t) {
                  e._callSectionWith(
                    a,
                    "onBlockDeselect",
                    t.target,
                    o.thisContext
                  );
                });
          }
        }),
        (e.sectionUnload = function (t) {
          for (
            var i = e._sectionForTarget(t), a = -1, o = 0;
            o < e._instances.length;
            o++
          )
            e._instances[o].target == t && (a = o);
          if (a > -1) {
            var n = e._instances[a];
            $(t).off("shopify:block:select shopify:block:deselect"),
              n.$shopifySectionContainer.off(
                "shopify:section:select shopify:section:deselect"
              ),
              e._callSectionWith(
                n.section,
                "onSectionUnload",
                t,
                n.thisContext
              ),
              e._unloadRegisteredEventListeners(
                n.thisContext.registeredEventListeners
              ),
              e._callSectionWith(
                i,
                "afterSectionUnloadCallback",
                t,
                n.thisContext
              ),
              e._instances.splice(a),
              $(t).data("components") &&
                $(t)
                  .data("components")
                  .split(",")
                  .forEach((e) => {
                    $(document).trigger("cc:component:unload", [e, t]);
                  });
          } else
            for (var o = 0; o < e._deferredSectionTargets.length; o++)
              if (e._deferredSectionTargets[o].target == t) {
                e._deferredSectionTargets[o].splice(o, 1);
                break;
              }
        }),
        (e.sectionReorder = function (t) {
          for (var i = -1, a = 0; a < e._instances.length; a++)
            e._instances[a].target == t && (i = a);
          if (i > -1) {
            var o = e._instances[i];
            e._callSectionWith(o.section, "onSectionReorder", t, o.thisContext);
          }
        }),
        (e._registerEventListener = function (e, t, i) {
          e.addEventListener(t, i),
            this.registeredEventListeners.push({
              element: e,
              eventType: t,
              callback: i,
            });
        }),
        (e._unloadRegisteredEventListeners = function (e) {
          e.forEach((e) => {
            e.element.removeEventListener(e.eventType, e.callback);
          });
        }),
        (e._callSectionWith = function (e, t, i, a) {
          if ("function" == typeof e[t])
            try {
              a ? e[t].bind(a)(i) : e[t](i);
            } catch (o) {
              var n = i.dataset.sectionType;
              console.warn(
                "Theme warning: '"
                  .concat(t, "' failed for section '")
                  .concat(n, "'")
              ),
                console.debug(i, o);
            }
        }),
        (e._themeSectionTargetFromShopifySectionTarget = function (e) {
          var t = $("[data-section-type]:first", e);
          return t.length > 0 && t[0];
        }),
        (e._sectionForTarget = function (t) {
          for (
            var i = $(t).attr("data-section-type"), a = 0;
            a < e._sections.length;
            a++
          )
            if (e._sections[a].type == i) return e._sections[a];
          return !1;
        }),
        (e._sectionAlreadyRegistered = function (t) {
          for (var i = 0; i < e._sections.length; i++)
            if (e._sections[i].type == t) return !0;
          return !1;
        });
    })()),
    (theme.scriptsLoaded = {}),
    (theme.loadScriptOnce = function (e, t, i, a) {
      if (void 0 === theme.scriptsLoaded[e]) {
        theme.scriptsLoaded[e] = [];
        var o = document.createElement("script");
        (o.src = e),
          (a || i) && (o.async = !1),
          i && i(),
          "function" == typeof t &&
            (theme.scriptsLoaded[e].push(t),
            o.readyState
              ? (o.onreadystatechange = function () {
                  if ("loaded" == o.readyState || "complete" == o.readyState) {
                    o.onreadystatechange = null;
                    for (var e = 0; e < theme.scriptsLoaded[this].length; e++)
                      theme.scriptsLoaded[this][e]();
                    theme.scriptsLoaded[this] = !0;
                  }
                }.bind(e))
              : (o.onload = function () {
                  for (var e = 0; e < theme.scriptsLoaded[this].length; e++)
                    theme.scriptsLoaded[this][e]();
                  theme.scriptsLoaded[this] = !0;
                }.bind(e)));
        var n = document.getElementsByTagName("script")[0];
        return n.parentNode.insertBefore(o, n), !0;
      }
      if ("object" != typeof theme.scriptsLoaded[e] || "function" != typeof t)
        return "function" == typeof t && t(), !1;
      theme.scriptsLoaded[e].push(t);
    }),
    (theme.loadStyleOnce = function (e) {
      var t = e.replace(/^https?:/, "");
      if (!document.querySelector('link[href="' + encodeURI(t) + '"]')) {
        var i = document.createElement("link");
        (i.href = t), (i.rel = "stylesheet"), (i.type = "text/css");
        var a = document.getElementsByTagName("link")[0];
        a.parentNode.insertBefore(i, a);
      }
    }),
    (theme.showQuickPopup = function (e, t) {
      var i = $('<div class="simple-popup"/>'),
        a = t.offset();
      i.html(e).css({ left: a.left, top: a.top }).hide(),
        $("body").append(i),
        i.css({
          marginTop: -i.outerHeight() - 10,
          marginLeft: -(i.outerWidth() - t.outerWidth()) / 2,
        }),
        i
          .fadeIn(200)
          .delay(3500)
          .fadeOut(400, function () {
            $(this).remove();
          });
    });
  class ccComponent {
    constructor(e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : ".cc-".concat(e),
        i = this;
      (this.instances = []),
        $(document).on("cc:component:load", function (a, o, n) {
          o === e &&
            $(n)
              .find("".concat(t, ":not(.cc-initialized)"))
              .each(function () {
                i.init(this);
              });
        }),
        $(document).on("cc:component:unload", function (a, o, n) {
          o === e &&
            $(n)
              .find(t)
              .each(function () {
                i.destroy(this);
              });
        }),
        $(t).each(function () {
          i.init(this);
        });
    }
    init(e) {
      $(e).addClass("cc-initialized");
    }
    destroy(e) {
      $(e).removeClass("cc-initialized");
    }
    registerInstance(e, t) {
      this.instances.push({ container: e, instance: t });
    }
    destroyInstance(e) {
      this.instances = this.instances.filter((t) => {
        if (t.container === e)
          return (
            "function" == typeof t.instance.destroy && t.instance.destroy(),
            t.container !== e
          );
      });
    }
  }
  (theme.createTemplateVariableEncoder = function () {
    return {
      utilityElement: document.createElement("div"),
      values: {},
      add: function e(t, i, a) {
        switch (a) {
          case "attribute":
            (this.utilityElement.innerHTML = ""),
              this.utilityElement.setAttribute("util", i),
              (this.values[t] =
                this.utilityElement.outerHTML.match(/util="([^"]*)"/)[1]);
            break;
          case "html":
            (this.utilityElement.innerText = i),
              (this.values[t] = this.utilityElement.innerHTML);
            break;
          case "raw":
            this.values[t] = i;
            break;
          default:
            throw "Type '".concat(a, "' not handled");
        }
      },
    };
  }),
    (theme.suffixIds = function (e, t) {
      var i = ["aria-describedby", "aria-controls"];
      (t = "-" + t),
        e.querySelectorAll("[id]").forEach((a) => {
          var o = a.id,
            n = o + t;
          (a.id = n),
            i.forEach((t) => {
              e.querySelectorAll("[".concat(t, '="').concat(o, '"]')).forEach(
                (e) => {
                  e.setAttribute(t, n);
                }
              );
            });
        });
    }),
    (theme.renderUnitPrice = function (e, t, i) {
      if (!e || !t) return "";
      var a = '<div class="unit-price">';
      (a += '<span class="unit-price__price theme-money">'.concat(
        theme.Shopify.formatMoney(e, i),
        "</span>"
      )),
        (a += '<span class="unit-price__separator">'.concat(
          theme.strings.products_product_unit_price_separator,
          "</span>"
        ));
      var o = t.reference_unit;
      return (
        1 != t.reference_value && (o = t.reference_value + o),
        (a += '<span class="unit-price__unit">'.concat(o, "</span>")),
        (a += "</div>")
      );
    });
  class ccPopup {
    constructor(e, t) {
      (this.$container = e),
        (this.namespace = t),
        (this.cssClasses = {
          visible: "cc-popup--visible",
          bodyNoScroll: "cc-popup-no-scroll",
          bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right",
        });
    }
    open(e) {
      if (this.$container.data("freeze-scroll")) {
        $("body").addClass(this.cssClasses.bodyNoScroll);
        var t = document.createElement("div");
        (t.className = "popup-scrollbar-measure"), document.body.appendChild(t);
        var i = t.getBoundingClientRect().width - t.clientWidth;
        document.body.removeChild(t),
          i > 0 &&
            $("body")
              .css("padding-right", i + "px")
              .addClass(this.cssClasses.bodyNoScrollPadRight);
      }
      this.$container.addClass(this.cssClasses.visible),
        (this.previouslyActiveElement = document.activeElement),
        setTimeout(() => {
          this.$container.find(".cc-popup-close")[0].focus();
        }, 500),
        $(window).on("keydown" + this.namespace, (e) => {
          27 === e.keyCode && this.close();
        }),
        e && e();
    }
    close(e) {
      if (
        (this.$container.removeClass(this.cssClasses.visible),
        this.previouslyActiveElement && $(this.previouslyActiveElement).focus(),
        $(window).off("keydown" + this.namespace),
        this.$container.data("freeze-scroll"))
      ) {
        var t = 500,
          i = this.$container.find(".cc-popup-modal");
        i.length &&
          (t = parseFloat(getComputedStyle(i[0]).transitionDuration)) &&
          t > 0 &&
          (t *= 1e3),
          setTimeout(() => {
            $("body")
              .removeClass(this.cssClasses.bodyNoScroll)
              .removeClass(this.cssClasses.bodyNoScrollPadRight)
              .css("padding-right", "0");
          }, t);
      }
      e && e();
    }
  }
  (() => {
    (theme.initAnimateOnScroll = function () {
      if (
        document.body.classList.contains("cc-animate-enabled") &&
        window.innerWidth >= 768
      ) {
        var e =
          void 0 !== document.body.dataset.ccAnimateTimeout
            ? document.body.dataset.ccAnimateTimeout
            : 200;
        if ("IntersectionObserver" in window) {
          var t = new IntersectionObserver((t, i) => {
            t.forEach((t) => {
              t.isIntersecting &&
                !t.target.classList.contains("cc-animate-complete") &&
                (setTimeout(() => {
                  t.target.classList.add("-in", "cc-animate-complete");
                }, e),
                setTimeout(() => {
                  t.target.classList.remove("data-cc-animate"),
                    (t.target.style.transitionDuration = null),
                    (t.target.style.transitionDelay = null);
                }, 5e3),
                i.unobserve(t.target));
            });
          });
          document
            .querySelectorAll("[data-cc-animate]:not(.cc-animate-init)")
            .forEach((e) => {
              e.dataset.ccAnimateDelay &&
                (e.style.transitionDelay = e.dataset.ccAnimateDelay),
                e.dataset.ccAnimateDuration &&
                  (e.style.transitionDuration = e.dataset.ccAnimateDuration),
                e.dataset.ccAnimate && e.classList.add(e.dataset.ccAnimate),
                e.classList.add("cc-animate-init"),
                t.observe(e);
            });
        } else
          for (
            var i = document.querySelectorAll(
                "[data-cc-animate]:not(.cc-animate-init)"
              ),
              a = 0;
            a < i.length;
            a++
          )
            i[a].classList.add("-in", "cc-animate-complete");
      }
    }),
      theme.initAnimateOnScroll(),
      document.addEventListener("shopify:section:load", () => {
        setTimeout(theme.initAnimateOnScroll, 100);
      });
    try {
      window
        .matchMedia("(min-width: 768px)")
        .addEventListener("change", (e) => {
          e.matches && setTimeout(theme.initAnimateOnScroll, 100);
        });
    } catch (e) {}
  })();
  class AccordionInstance {
    constructor(e) {
      (this.accordion = e),
        (this.itemClass = ".cc-accordion-item"),
        (this.titleClass = ".cc-accordion-item__title"),
        (this.panelClass = ".cc-accordion-item__panel"),
        (this.allowMultiOpen =
          "true" === this.accordion.dataset.allowMultiOpen),
        this.allowMultiOpen ||
          (this.activeItem = this.accordion.querySelector(
            "".concat(this.itemClass, "[open]")
          )),
        this.bindEvents();
    }
    static addPanelHeight(e) {
      e.style.height = "".concat(e.scrollHeight, "px");
    }
    static removePanelHeight(e) {
      e.getAttribute("style"), e.removeAttribute("style");
    }
    open(e, t) {
      if (
        ((t.style.height = "0"),
        (e.open = !0),
        AccordionInstance.addPanelHeight(t),
        setTimeout(() => {
          e.classList.add("is-open");
        }, 10),
        !this.allowMultiOpen)
      ) {
        if (this.activeItem && this.activeItem !== e) {
          var i = this.activeItem.querySelector(this.panelClass);
          this.close(this.activeItem, i);
        }
        this.activeItem = e;
      }
    }
    close(e, t) {
      AccordionInstance.addPanelHeight(t),
        e.classList.remove("is-open"),
        e.classList.add("is-closing"),
        this.activeItem === e && (this.activeItem = null),
        setTimeout(() => {
          t.style.height = "0";
        }, 10);
    }
    handleClick(e) {
      var t = e.target.closest(this.titleClass);
      if (t) {
        e.preventDefault();
        var i = t.parentNode,
          a = t.nextElementSibling;
        i.open ? this.close(i, a) : this.open(i, a);
      }
    }
    handleTransition(e) {
      if (e.target.matches(this.panelClass)) {
        var t = e.target,
          i = t.parentNode;
        i.classList.contains("is-closing") &&
          (i.classList.remove("is-closing"), (i.open = !1)),
          AccordionInstance.removePanelHeight(t);
      }
    }
    bindEvents() {
      (this.clickHandler = this.handleClick.bind(this)),
        (this.transitionHandler = this.handleTransition.bind(this)),
        this.accordion.addEventListener("click", this.clickHandler),
        this.accordion.addEventListener(
          "transitionend",
          this.transitionHandler
        );
    }
    destroy() {
      this.accordion.removeEventListener("click", this.clickHandler),
        this.accordion.removeEventListener(
          "transitionend",
          this.transitionHandler
        );
    }
  }
  class Accordion extends ccComponent {
    constructor() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : "accordion",
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : ".cc-".concat(e);
      super(e, t);
    }
    init(e) {
      super.init(e), this.registerInstance(e, new AccordionInstance(e));
    }
    destroy(e) {
      this.destroyInstance(e), super.destroy(e);
    }
  }
  new Accordion();
  class CustomSelectInstance {
    constructor(e) {
      (this.el = e),
        (this.button = e.querySelector(".cc-select__btn")),
        (this.listbox = e.querySelector(".cc-select__listbox")),
        (this.options = e.querySelectorAll(".cc-select__option")),
        (this.selectedOption = e.querySelector('[aria-selected="true"]')),
        (this.nativeSelect = document.getElementById(
          "".concat(e.id, "-native")
        )),
        (this.swatches =
          "swatch" in this.options[this.options.length - 1].dataset),
        (this.focusedClass = "is-focused"),
        (this.searchString = ""),
        (this.listboxOpen = !1),
        this.selectedOption ||
          (this.selectedOption = this.listbox.firstElementChild),
        this.bindEvents(),
        this.setButtonWidth();
    }
    bindEvents() {
      this.el.addEventListener("keydown", this.handleKeydown.bind(this)),
        this.button.addEventListener(
          "mousedown",
          this.handleMousedown.bind(this)
        );
    }
    addListboxOpenEvents() {
      (this.mouseoverHandler = this.handleMouseover.bind(this)),
        (this.mouseleaveHandler = this.handleMouseleave.bind(this)),
        (this.clickHandler = this.handleClick.bind(this)),
        (this.blurHandler = this.handleBlur.bind(this)),
        this.listbox.addEventListener("mouseover", this.mouseoverHandler),
        this.listbox.addEventListener("mouseleave", this.mouseleaveHandler),
        this.listbox.addEventListener("click", this.clickHandler),
        this.listbox.addEventListener("blur", this.blurHandler);
    }
    removeListboxOpenEvents() {
      this.listbox.removeEventListener("mouseover", this.mouseoverHandler),
        this.listbox.removeEventListener("mouseleave", this.mouseleaveHandler),
        this.listbox.removeEventListener("click", this.clickHandler),
        this.listbox.removeEventListener("blur", this.blurHandler);
    }
    handleKeydown(e) {
      this.listboxOpen
        ? this.handleKeyboardNav(e)
        : ("ArrowUp" === e.key || "ArrowDown" === e.key || " " === e.key) &&
          (e.preventDefault(), this.showListbox());
    }
    handleMousedown(e) {
      this.listboxOpen || 0 !== e.button || this.showListbox();
    }
    handleMouseover(e) {
      e.target.matches("li") && this.focusOption(e.target);
    }
    handleMouseleave() {
      this.focusOption(this.selectedOption);
    }
    handleClick(e) {
      e.target.matches(".js-option") && this.selectOption(e.target);
    }
    handleBlur() {
      this.listboxOpen && this.hideListbox();
    }
    handleKeyboardNav(e) {
      var t;
      switch (("Tab" === e.key && e.preventDefault(), e.key)) {
        case "ArrowUp":
        case "ArrowDown":
          e.preventDefault(),
            (t =
              "ArrowUp" === e.key
                ? this.focusedOption.previousElementSibling
                : this.focusedOption.nextElementSibling) &&
              !t.classList.contains("is-disabled") &&
              this.focusOption(t);
          break;
        case "Enter":
        case " ":
          e.preventDefault(), this.selectOption(this.focusedOption);
          break;
        case "Escape":
          e.preventDefault(), this.hideListbox();
          break;
        default:
          (t = this.findOption(e.key)) && this.focusOption(t);
      }
    }
    setButtonWidth() {
      var e = (e) => {
          var t = getComputedStyle(e);
          return parseFloat(t.paddingLeft) + parseFloat(t.paddingRight);
        },
        t = e(this.button),
        i = e(this.selectedOption),
        a = this.button.offsetWidth - this.button.clientWidth,
        o = Math.ceil(this.selectedOption.getBoundingClientRect().width);
      this.button.style.width = "".concat(o - i + t + a, "px");
    }
    showListbox() {
      (this.listbox.hidden = !1),
        (this.listboxOpen = !0),
        this.el.classList.add("is-open"),
        this.button.setAttribute("aria-expanded", "true"),
        this.listbox.setAttribute("aria-hidden", "false"),
        setTimeout(() => {
          this.focusOption(this.selectedOption),
            this.listbox.focus(),
            this.addListboxOpenEvents();
        }, 10);
    }
    hideListbox() {
      this.listboxOpen &&
        ((this.listbox.hidden = !0),
        (this.listboxOpen = !1),
        this.el.classList.remove("is-open"),
        this.button.setAttribute("aria-expanded", "false"),
        this.listbox.setAttribute("aria-hidden", "true"),
        this.focusedOption &&
          (this.focusedOption.classList.remove(this.focusedClass),
          (this.focusedOption = null)),
        this.button.focus(),
        this.removeListboxOpenEvents());
    }
    findOption(e) {
      return (
        (this.searchString += e),
        this.searchTimer && clearTimeout(this.searchTimer),
        (this.searchTimer = setTimeout(() => {
          this.searchString = "";
        }, 500)),
        [...this.options].find(
          (e) =>
            e.innerText.toLowerCase().includes(this.searchString) &&
            !e.classList.contains("is-disabled")
        )
      );
    }
    focusOption(e) {
      if (
        (this.focusedOption &&
          this.focusedOption.classList.remove(this.focusedClass),
        (this.focusedOption = e),
        this.focusedOption.classList.add(this.focusedClass),
        this.listbox.scrollHeight > this.listbox.clientHeight)
      ) {
        var t = this.listbox.clientHeight + this.listbox.scrollTop,
          i = e.offsetTop + e.offsetHeight;
        i > t
          ? (this.listbox.scrollTop = i - this.listbox.clientHeight)
          : e.offsetTop < this.listbox.scrollTop &&
            (this.listbox.scrollTop = e.offsetTop);
      }
    }
    selectOption(e) {
      if (e !== this.selectedOption) {
        if (
          (e.setAttribute("aria-selected", "true"),
          this.selectedOption.setAttribute("aria-selected", "false"),
          this.swatches &&
            (e.dataset.swatch
              ? (this.button.dataset.swatch = e.dataset.swatch)
              : this.button.removeAttribute("data-swatch")),
          (this.button.firstChild.textContent =
            e.firstElementChild.textContent),
          this.listbox.setAttribute("aria-activedescendant", e.id),
          (this.selectedOption = document.getElementById(e.id)),
          this.nativeSelect)
        )
          (this.nativeSelect.value = e.dataset.value),
            this.nativeSelect.dispatchEvent(
              new Event("change", { bubbles: !0 })
            );
        else {
          var t = { selectedValue: e.dataset.value };
          this.el.dispatchEvent(
            new CustomEvent("change", { bubbles: !0, detail: t })
          );
        }
      }
      this.hideListbox();
    }
  }
  class CustomSelect extends ccComponent {
    constructor() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : "custom-select",
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : ".cc-select";
      super(e, t);
    }
    init(e) {
      super.init(e), this.registerInstance(e, new CustomSelectInstance(e));
    }
    destroy(e) {
      this.destroyInstance(e), super.destroy(e);
    }
  }
  new CustomSelect();
  class ModalInstance {
    constructor(e) {
      (this.container = e),
        (this.size = e.dataset.ccModalSize || "medium"),
        (this.contentElement = document.querySelector(
          e.dataset.ccModalContentelement
        )),
        this.container.addEventListener("click", this.handleClick.bind(this)),
        "true" === e.dataset.ccModalLaunch &&
          setTimeout(this.open.bind(this), 10);
    }
    handleClick(e) {
      e.preventDefault(), this.open(), (this.opener = e.target);
    }
    open() {
      var e = theme.createTemplateVariableEncoder();
      e.add("size", this.size, "attribute"),
        e.add("content", this.contentElement.innerHTML, "raw"),
        e.add(
          "button_close_label",
          theme.strings.general_accessibility_labels_close,
          "attribute"
        ),
        e.add("button_close_icon", theme.icons.close, "raw");
      var t =
          '\n      <div class="cc-modal-window cc-modal-window--pre-reveal cc-modal-window--size-'
            .concat(
              e.values.size,
              '">\n        <div class="cc-modal-window__background"></div>\n        <div class="cc-modal-window__foreground" role="dialog" aria-modal="true">\n          <div class="cc-modal-window__content-container">\n            <button class="cc-modal-window__close" aria-label="'
            )
            .concat(e.values.button_close_label, '">')
            .concat(
              e.values.button_close_icon,
              '</button>\n            <div class="cc-modal-window__content">'
            )
            .concat(
              e.values.content,
              "</div>\n          </div>\n        </div>\n      </div>\n    "
            ),
        i = document.createRange().createContextualFragment(t);
      document.body.appendChild(i),
        document.body.classList.add("cc-modal-visible"),
        (this.modalElement = document.body.lastElementChild),
        this.modalElement
          .querySelector(".cc-modal-window__background")
          .addEventListener("click", this.close.bind(this)),
        this.modalElement
          .querySelector(".cc-modal-window__close")
          .addEventListener("click", this.close.bind(this)),
        setTimeout(() => {
          this.modalElement.classList.remove("cc-modal-window--pre-reveal"),
            this.modalElement.querySelector(".cc-modal-window__close").focus();
        }, 10);
    }
    close() {
      this.modalElement.classList.add("cc-modal-window--closing"),
        document.querySelector(
          ".cc-modal-window:not(.cc-modal-window--closing)"
        ) || document.body.classList.remove("cc-modal-visible"),
        this.opener &&
          setTimeout(() => {
            this.opener.focus();
          }, 10),
        setTimeout(
          function () {
            this.remove();
          }.bind(this.modalElement),
          5e3
        );
    }
  }
  class Modal extends ccComponent {
    constructor() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : "modal",
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : ".cc-".concat(e);
      super(e, t);
    }
    init(e) {
      super.init(e), this.registerInstance(e, new ModalInstance(e));
    }
    destroy(e) {
      this.destroyInstance(e), super.destroy(e);
    }
  }
  new Modal();
  class PriceRangeInstance {
    constructor(e) {
      (this.container = e),
        (this.selectors = {
          inputMin: ".cc-price-range__input--min",
          inputMax: ".cc-price-range__input--max",
          control: ".cc-price-range__control",
          controlMin: ".cc-price-range__control--min",
          controlMax: ".cc-price-range__control--max",
          bar: ".cc-price-range__bar",
          activeBar: ".cc-price-range__bar-active",
        }),
        (this.controls = {
          min: {
            barControl: e.querySelector(this.selectors.controlMin),
            input: e.querySelector(this.selectors.inputMin),
          },
          max: {
            barControl: e.querySelector(this.selectors.controlMax),
            input: e.querySelector(this.selectors.inputMax),
          },
        }),
        (this.controls.min.value = parseInt(
          "" === this.controls.min.input.value
            ? this.controls.min.input.placeholder
            : this.controls.min.input.value
        )),
        (this.controls.max.value = parseInt(
          "" === this.controls.max.input.value
            ? this.controls.max.input.placeholder
            : this.controls.max.input.value
        )),
        (this.valueMin = 100),
        (this.valueMax = this.controls.min.input.max),
        (this.valueRange = this.valueMax - this.valueMin),
        [this.controls.min, this.controls.max].forEach((e) => {
          e.barControl.setAttribute("aria-valuemin", this.valueMin),
            e.barControl.setAttribute("aria-valuemax", this.valueMax),
            e.barControl.setAttribute("tabindex", 0);
        }),
        this.controls.min.barControl.setAttribute(
          "aria-valuenow",
          this.controls.min.value
        ),
        this.controls.max.barControl.setAttribute(
          "aria-valuenow",
          this.controls.max.value
        ),
        (this.bar = e.querySelector(this.selectors.bar)),
        (this.activeBar = e.querySelector(this.selectors.activeBar)),
        (this.inDrag = !1),
        this.bindEvents(),
        this.render();
    }
    getPxToValueRatio() {
      return this.bar.clientWidth / (this.valueMax - this.valueMin);
    }
    getPcToValueRatio() {
      return 100 / (this.valueMax - this.valueMin);
    }
    setActiveControlValue(e) {
      isNaN(parseInt(e)) ||
        (this.activeControl === this.controls.min
          ? ("" === e && (e = this.valueMin),
            (e = Math.min(
              (e = Math.max(this.valueMin, e)),
              this.controls.max.value
            )))
          : ("" === e && (e = this.valueMax),
            (e = Math.max(
              (e = Math.min(this.valueMax, e)),
              this.controls.min.value
            ))),
        (this.activeControl.value = Math.round(e)),
        this.activeControl.input.value != this.activeControl.value &&
          (this.activeControl.value == this.activeControl.input.placeholder
            ? (this.activeControl.input.value = "")
            : (this.activeControl.input.value = this.activeControl.value),
          this.activeControl.input.dispatchEvent(
            new CustomEvent("change", {
              bubbles: !0,
              cancelable: !1,
              detail: { sender: "theme:component:price_range" },
            })
          )),
        this.activeControl.barControl.setAttribute(
          "aria-valuenow",
          this.activeControl.value
        ));
    }
    render() {
      this.drawControl(this.controls.min),
        this.drawControl(this.controls.max),
        this.drawActiveBar();
    }
    drawControl(e) {
      e.barControl.style.left =
        (e.value - this.valueMin) * this.getPcToValueRatio() + "%";
    }
    drawActiveBar() {
      (this.activeBar.style.left =
        (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() +
        "%"),
        (this.activeBar.style.right =
          (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() +
          "%");
    }
    handleControlTouchStart(e) {
      e.preventDefault(),
        this.startDrag(e.target, e.touches[0].clientX),
        (this.boundControlTouchMoveEvent =
          this.handleControlTouchMove.bind(this)),
        (this.boundControlTouchEndEvent =
          this.handleControlTouchEnd.bind(this)),
        window.addEventListener("touchmove", this.boundControlTouchMoveEvent),
        window.addEventListener("touchend", this.boundControlTouchEndEvent);
    }
    handleControlTouchMove(e) {
      this.moveDrag(e.touches[0].clientX);
    }
    handleControlTouchEnd(e) {
      e.preventDefault(),
        window.removeEventListener(
          "touchmove",
          this.boundControlTouchMoveEvent
        ),
        window.removeEventListener("touchend", this.boundControlTouchEndEvent),
        this.stopDrag();
    }
    handleControlMouseDown(e) {
      e.preventDefault(),
        this.startDrag(e.target, e.clientX),
        (this.boundControlMouseMoveEvent =
          this.handleControlMouseMove.bind(this)),
        (this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this)),
        window.addEventListener("mousemove", this.boundControlMouseMoveEvent),
        window.addEventListener("mouseup", this.boundControlMouseUpEvent);
    }
    handleControlMouseMove(e) {
      this.moveDrag(e.clientX);
    }
    handleControlMouseUp(e) {
      e.preventDefault(),
        window.removeEventListener(
          "mousemove",
          this.boundControlMouseMoveEvent
        ),
        window.removeEventListener("mouseup", this.boundControlMouseUpEvent),
        this.stopDrag();
    }
    startDrag(e, t) {
      this.controls.min.barControl === e
        ? (this.activeControl = this.controls.min)
        : (this.activeControl = this.controls.max),
        (this.dragStartX = t),
        (this.dragStartValue = this.activeControl.value),
        (this.inDrag = !0);
    }
    moveDrag(e) {
      if (this.inDrag) {
        var t =
          this.dragStartValue +
          (e - this.dragStartX) / this.getPxToValueRatio();
        this.setActiveControlValue(t), this.render();
      }
    }
    stopDrag() {
      this.inDrag = !1;
    }
    handleControlKeyDown(e) {
      "ArrowRight" === e.key
        ? this.incrementControlFromKeypress(e.target, 10)
        : "ArrowLeft" === e.key &&
          this.incrementControlFromKeypress(e.target, -10);
    }
    incrementControlFromKeypress(e, t) {
      this.controls.min.barControl === e
        ? (this.activeControl = this.controls.min)
        : (this.activeControl = this.controls.max),
        this.setActiveControlValue(
          this.activeControl.value + t / this.getPxToValueRatio()
        ),
        this.render();
    }
    handleInputChange(e) {
      (e.target.value = e.target.value.replace(/\D/g, "")),
        (e.detail && "theme:component:price_range" == e.detail.sender) ||
          (this.controls.min.input === e.target
            ? (this.activeControl = this.controls.min)
            : (this.activeControl = this.controls.max),
          this.setActiveControlValue(e.target.value),
          this.render());
    }
    handleInputKeyup(e) {
      setTimeout(
        function () {
          this.value = this.value.replace(/\D/g, "");
        }.bind(e.target),
        10
      );
    }
    bindEvents() {
      [this.controls.min, this.controls.max].forEach((e) => {
        e.barControl.addEventListener(
          "touchstart",
          this.handleControlTouchStart.bind(this)
        ),
          e.barControl.addEventListener(
            "mousedown",
            this.handleControlMouseDown.bind(this)
          ),
          e.barControl.addEventListener(
            "keydown",
            this.handleControlKeyDown.bind(this)
          ),
          e.input.addEventListener("change", this.handleInputChange.bind(this)),
          e.input.addEventListener("keyup", this.handleInputKeyup.bind(this));
      });
    }
    destroy() {}
  }
  document.addEventListener("DOMContentLoaded", function () {
    const priceRangeContainer = document.querySelector(".cc-price-range");
    if (priceRangeContainer) {
      const priceRangeInstance = new PriceRangeInstance(priceRangeContainer);
      priceRangeInstance.valueMin = 0;
      priceRangeInstance.render();
    }
  });
  class PriceRange extends ccComponent {
    constructor() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : "price-range".concat(e),
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : ".cc-".concat(e);
      super(e, t);
    }
    init(e) {
      super.init(e), this.registerInstance(e, new PriceRangeInstance(e));
    }
    destroy(e) {
      this.destroyInstance(e), super.destroy(e);
    }
  }
  new PriceRange(),
    (theme.VideoManager = new (function () {
      var e = this;
      (e._permitPlayback = function (e) {
        return !(
          $(e).hasClass("video-container--background") &&
          768 > $(window).outerWidth()
        );
      }),
        (e.youtubeVars = {
          incrementor: 0,
          apiReady: !1,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="youtube"]:not(.video--init)',
        }),
        (e.youtubeApiReady = function () {
          (e.youtubeVars.apiReady = !0), e._loadYoutubeVideos();
        }),
        (e._loadYoutubeVideos = function (t) {
          $(e.youtubeVars.toProcessSelector, t).length &&
            (e.youtubeVars.apiReady
              ? $(e.youtubeVars.toProcessSelector, t).each(function () {
                  if (e._permitPlayback($(this))) {
                    $(this).addClass("video--init"),
                      e.youtubeVars.incrementor++;
                    var t = "theme-yt-video-" + e.youtubeVars.incrementor;
                    $(this).data("video-container-id", t);
                    var i = $('<div class="video-container__video-element">')
                        .attr("id", t)
                        .appendTo($(".video-container__video", this)),
                      a = $(this).data("video-autoplay"),
                      o = $(this).data("video-loop"),
                      n = new YT.Player(t, {
                        height: "360",
                        width: "640",
                        videoId: $(this).data("video-id"),
                        playerVars: {
                          iv_load_policy: 3,
                          modestbranding: 1,
                          autoplay: 0,
                          loop: o ? 1 : 0,
                          playlist: $(this).data("video-id"),
                          rel: 0,
                          showinfo: 0,
                        },
                        events: {
                          onReady: e._onYoutubePlayerReady.bind({
                            autoplay: a,
                            loop: o,
                            $container: $(this),
                          }),
                          onStateChange: e._onYoutubePlayerStateChange.bind({
                            autoplay: a,
                            loop: o,
                            $container: $(this),
                          }),
                        },
                      });
                    e.youtubeVars.videoData[t] = {
                      id: t,
                      container: this,
                      videoElement: i,
                      player: n,
                    };
                  }
                })
              : theme.loadScriptOnce("https://www.youtube.com/iframe_api"));
        }),
        (e._onYoutubePlayerReady = function (t) {
          t.target.setPlaybackQuality("hd1080"),
            this.autoplay && (t.target.mute(), t.target.playVideo()),
            e._initBackgroundVideo(this.$container);
        }),
        (e._onYoutubePlayerStateChange = function (e) {
          if (
            e.data == YT.PlayerState.PLAYING &&
            (this.$container.addClass("video--play-started"),
            this.autoplay && e.target.mute(),
            this.loop)
          ) {
            var t = e.target.getDuration() - 1;
            if (t > 2) {
              function i() {
                e.target.getCurrentTime() > t && e.target.seekTo(0),
                  setTimeout(i, 250);
              }
              i();
            }
          }
        }),
        (e._unloadYoutubeVideos = function (t) {
          for (var i in e.youtubeVars.videoData) {
            var a = e.youtubeVars.videoData[i];
            if ($(t).find(a.container).length) {
              a.player.destroy(), delete e.youtubeVars.videoData[i];
              return;
            }
          }
        }),
        (e.vimeoVars = {
          incrementor: 0,
          apiReady: !1,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="vimeo"]:not(.video--init)',
        }),
        (e.vimeoApiReady = function () {
          (e.vimeoVars.apiReady = !0), e._loadVimeoVideos();
        }),
        (e._loadVimeoVideos = function (t) {
          $(e.vimeoVars.toProcessSelector, t).length &&
            (e.vimeoVars.apiReady
              ? $(e.vimeoVars.toProcessSelector, t).each(function () {
                  if (e._permitPlayback($(this))) {
                    $(this).addClass("video--init"), e.vimeoVars.incrementor++;
                    var t = $(this),
                      i = "theme-vi-video-" + e.vimeoVars.incrementor;
                    $(this).data("video-container-id", i);
                    var a = $('<div class="video-container__video-element">')
                        .attr("id", i)
                        .appendTo($(".video-container__video", this)),
                      o = !!$(this).data("video-autoplay"),
                      n = new Vimeo.Player(i, {
                        url: $(this).data("video-url"),
                        width: 640,
                        loop: $(this).data("video-autoplay"),
                        autoplay: o,
                        muted: t.hasClass("video-container--background") || o,
                      });
                    n.on(
                      "playing",
                      function () {
                        $(this).addClass("video--play-started");
                      }.bind(this)
                    ),
                      n.ready().then(function () {
                        if (
                          (o && (n.setVolume(0), n.play()),
                          n.element && n.element.width && n.element.height)
                        ) {
                          var i =
                            parseInt(n.element.height) /
                            parseInt(n.element.width);
                          t.find(".video-container__video").css(
                            "padding-bottom",
                            100 * i + "%"
                          );
                        }
                        e._initBackgroundVideo(t);
                      }),
                      (e.vimeoVars.videoData[i] = {
                        id: i,
                        container: this,
                        videoElement: a,
                        player: n,
                        autoPlay: o,
                      });
                  }
                })
              : window.define
              ? theme.loadScriptOnce(
                  "https://player.vimeo.com/api/player.js",
                  function () {
                    (e.vimeoVars.apiReady = !0),
                      e._loadVimeoVideos(),
                      (window.define = window.tempDefine);
                  },
                  function () {
                    (window.tempDefine = window.define), (window.define = null);
                  }
                )
              : theme.loadScriptOnce(
                  "https://player.vimeo.com/api/player.js",
                  function () {
                    (e.vimeoVars.apiReady = !0), e._loadVimeoVideos();
                  }
                ));
        }),
        (e._unloadVimeoVideos = function (t) {
          for (var i in e.vimeoVars.videoData) {
            var a = e.vimeoVars.videoData[i];
            if ($(t).find(a.container).length) {
              a.player.unload(), delete e.vimeoVars.videoData[i];
              return;
            }
          }
        }),
        (e._loadThirdPartyApis = function (t) {
          e._permitPlayback($(".video-container", t)) &&
            (e._loadYoutubeVideos(t), e._loadVimeoVideos(t));
        }),
        (e.mp4Vars = {
          incrementor: 0,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="mp4"]:not(.video--init)',
        }),
        (e._loadMp4Videos = function (t) {
          $(e.mp4Vars.toProcessSelector, t).length &&
            $(e.mp4Vars.toProcessSelector, t)
              .addClass("video--init")
              .each(function () {
                e.mp4Vars.incrementor++, $(this);
                var t = "theme-mp-video-" + e.mp4Vars.incrementor;
                $(this).data("video-container-id", t);
                var i = $('<div class="video-container__video-element">')
                    .attr("id", t)
                    .appendTo($(".video-container__video", this)),
                  a = $("<video playsinline>");
                $(this).data("video-loop") && a.attr("loop", "loop"),
                  $(this).hasClass("video-container--background") ||
                    a.attr("controls", "controls"),
                  $(this).data("video-autoplay") &&
                    (a.attr({ autoplay: "autoplay", muted: "muted" }),
                    (a[0].muted = !0),
                    a.one("loadeddata", function () {
                      this.play();
                    })),
                  a.on(
                    "playing",
                    function () {
                      $(this).addClass("video--play-started");
                    }.bind(this)
                  ),
                  a.attr("src", $(this).data("video-url")).appendTo(i),
                  (e.mp4Vars.videoData[t] = { element: a[0] });
              });
        }),
        (e._unloadMp4Videos = function (e) {}),
        (e._initBackgroundVideo = function (e) {
          if (
            e.hasClass("video-container--background") &&
            e.find(".video-container__video iframe").length
          ) {
            function t() {
              var e = $(".video-container__media", this),
                t = e.length ? e : this,
                i = t.width(),
                a = t.height(),
                o = i / a,
                n = $(".video-container__video iframe", this),
                s = n.attr("width") / n.attr("height"),
                r = $(".video-container__video", this),
                l = 75;
              if (o > s) {
                var c = i / s + 2 * l;
                r.css({
                  marginTop: (a - c) / 2 - l,
                  marginLeft: "",
                  height: c + 2 * l,
                  width: "",
                });
              } else {
                var d = i * s + 2 * l * s;
                r.css({
                  marginTop: -l,
                  marginLeft: (i - d) / 2,
                  height: a + 2 * l,
                  width: d,
                });
              }
            }
            t.bind(e)(),
              $(window).on(
                "debouncedresize." + e.data("video-container-id"),
                t.bind(e)
              );
          }
        }),
        (this.onSectionLoad = function (t) {
          $(".video-container[data-video-url]:not([data-video-type])").each(
            function () {
              var e = $(this).data("video-url");
              e.indexOf(".mp4") > -1 && $(this).attr("data-video-type", "mp4"),
                e.indexOf("vimeo.com") > -1 &&
                  ($(this).attr("data-video-type", "vimeo"),
                  $(this).attr(
                    "data-video-id",
                    e.split("?")[0].split("/").pop()
                  )),
                (e.indexOf("youtu.be") > -1 || e.indexOf("youtube.com") > -1) &&
                  ($(this).attr("data-video-type", "youtube"),
                  e.indexOf("v=") > -1
                    ? $(this).attr(
                        "data-video-id",
                        e.split("v=").pop().split("&")[0]
                      )
                    : $(this).attr(
                        "data-video-id",
                        e.split("?")[0].split("/").pop()
                      ));
            }
          ),
            e._loadThirdPartyApis(t),
            e._loadMp4Videos(t),
            $(window).on("debouncedresize.video-manager-resize", function () {
              e._loadThirdPartyApis(t);
            }),
            $(".video-container__play", t).on("click", function (i) {
              i.preventDefault();
              var a = $(this).closest(".video-container");
              a.addClass("video-container--playing"),
                $(t).trigger("cc:video:play");
              var o = a.data("video-container-id");
              0 === o.indexOf("theme-yt-video")
                ? e.youtubeVars.videoData[o].player.playVideo()
                : 0 === o.indexOf("theme-vi-video")
                ? e.vimeoVars.videoData[o].player.play()
                : 0 === o.indexOf("theme-mp-video") &&
                  e.mp4Vars.videoData[o].element.play();
            }),
            $(".video-container__stop", t).on("click", function (i) {
              i.preventDefault();
              var a = $(this).closest(".video-container");
              a.removeClass("video-container--playing"),
                $(t).trigger("cc:video:stop");
              var o = a.data("video-container-id");
              0 === o.indexOf("theme-yt-video")
                ? e.youtubeVars.videoData[o].player.stopVideo()
                : (e.vimeoVars.videoData[o].player.pause(),
                  e.vimeoVars.videoData[o].player.setCurrentTime(0));
            });
        }),
        (this.onSectionUnload = function (t) {
          $(".video-container__play, .video-container__stop", t).off("click"),
            $(window).off(
              "." + $(".video-container").data("video-container-id")
            ),
            $(window).off("debouncedresize.video-manager-resize"),
            e._unloadYoutubeVideos(t),
            e._unloadVimeoVideos(t),
            e._unloadMp4Videos(t),
            $(t).trigger("cc:video:stop");
        });
    })()),
    (window.onYouTubeIframeAPIReady = function () {
      theme.VideoManager.youtubeApiReady();
    }),
    cc.sections.push({ name: "video", section: theme.VideoManager }),
    (theme.MapSection = new (function () {
      var e = this;
      (e.config = {
        zoom: 14,
        styles: {
          default: [],
          silver: [
            { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f5f5" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#ffffff" }],
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#dadada" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#c9c9c9" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
          ],
          retro: [
            { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#523735" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [{ color: "#c9b2a6" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "geometry.stroke",
              stylers: [{ color: "#dcd2be" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#ae9e90" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#93817c" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#a5b076" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#447530" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#fdfcf8" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#f8c967" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#e9bc62" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#e98d58" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry.stroke",
              stylers: [{ color: "#db8555" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#806b63" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8f7d77" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#ebe3cd" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [{ color: "#b9d3c2" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#92998d" }],
            },
          ],
          dark: [
            { elementType: "geometry", stylers: [{ color: "#212121" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#212121" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "administrative.country",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "administrative.land_parcel",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#181818" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1b1b1b" }],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [{ color: "#2c2c2c" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8a8a8a" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#373737" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#3c3c3c" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#4e4e4e" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#000000" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3d3d3d" }],
            },
          ],
          night: [
            { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#746855" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#242f3e" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#263c3f" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6b9a76" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#38414e" }],
            },
            {
              featureType: "road",
              elementType: "geometry.stroke",
              stylers: [{ color: "#212a37" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9ca5b3" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#746855" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#1f2835" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#f3d19c" }],
            },
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [{ color: "#2f3948" }],
            },
            {
              featureType: "transit.station",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#17263c" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#515c6d" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#17263c" }],
            },
          ],
          aubergine: [
            { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#8ec3b9" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1a3646" }],
            },
            {
              featureType: "administrative.country",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#64779e" }],
            },
            {
              featureType: "administrative.province",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "landscape.man_made",
              elementType: "geometry.stroke",
              stylers: [{ color: "#334e87" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6f9ba5" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3C7680" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#304a7d" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#2c6675" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#255763" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#b0d5ce" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry.fill",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#3a4762" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#0e1626" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#4e6d70" }],
            },
          ],
        },
      }),
        (e.apiStatus = null),
        (this.geolocate = function (e) {
          var t = $.Deferred(),
            i = new google.maps.Geocoder(),
            a = e.data("address-setting");
          return (
            i.geocode({ address: a }, function (e, i) {
              i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e);
            }),
            t
          );
        }),
        (this.createMap = function (t) {
          var i = $(".map-section__map-container", t);
          return e
            .geolocate(i)
            .then(
              function (a) {
                var o = {
                  zoom: e.config.zoom,
                  styles: e.config.styles[$(t).data("map-style")],
                  center: a[0].geometry.location,
                  scrollwheel: !1,
                  disableDoubleClickZoom: !0,
                  disableDefaultUI: !0,
                  zoomControl: !0,
                };
                (e.map = new google.maps.Map(i[0], o)),
                  (e.center = e.map.getCenter()),
                  new google.maps.Marker({
                    map: e.map,
                    position: e.center,
                    clickable: !1,
                  }),
                  google.maps.event.addDomListener(
                    window,
                    "resize",
                    function () {
                      google.maps.event.trigger(e.map, "resize"),
                        e.map.setCenter(e.center);
                    }
                  );
              }.bind(this)
            )
            .fail(function () {
              var e;
              switch (status) {
                case "ZERO_RESULTS":
                  e = theme.strings.addressNoResults;
                  break;
                case "OVER_QUERY_LIMIT":
                  e = theme.strings.addressQueryLimit;
                  break;
                default:
                  e = theme.strings.addressError;
              }
              if (Shopify.designMode) {
                var t = i.parents(".map-section");
                t.addClass("page-width map-section--load-error"),
                  t
                    .find(".map-section__wrapper")
                    .html('<div class="errors text-center">' + e + "</div>");
              }
            });
        }),
        (this.onSectionLoad = function (t) {
          var i = $(t);
          window.gm_authFailure = function () {
            Shopify.designMode &&
              (i.addClass("page-width map-section--load-error"),
              i
                .find(".map-section__wrapper")
                .html(
                  '<div class="errors text-center">' +
                    theme.strings.authError +
                    "</div>"
                ));
          };
          var a = i.data("api-key");
          "string" == typeof a &&
            "" !== a &&
            theme.loadScriptOnce(
              "https://maps.googleapis.com/maps/api/js?key=" + a,
              function () {
                e.createMap(i);
              }
            );
        }),
        (this.onSectionUnload = function (t) {
          void 0 !== window.google &&
            void 0 !== google.maps &&
            google.maps.event.clearListeners(e.map, "resize");
        });
    })()),
    cc.sections.push({ name: "map", section: theme.MapSection }),
    (theme.FaqHeader = new (function () {
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.container = e),
          (this.classNames = {
            questionContainerInactive: "faq-search-item-inactive",
            sectionWithIndexStatus: "section-faq-header--with-index",
          }),
          (this.searchInput =
            this.container.querySelector(".faq-search__input")),
          this.searchInput &&
            (this.registerEventListener(
              this.searchInput,
              "change",
              this.functions.performSearch.bind(this)
            ),
            this.registerEventListener(
              this.searchInput,
              "keyup",
              this.functions.performSearch.bind(this)
            ),
            this.registerEventListener(
              this.searchInput,
              "paste",
              this.functions.performSearch.bind(this)
            )),
          (this.functions.debouncedBuildIndex = theme.debounce(
            this.functions.buildIndex.bind(this),
            50
          )),
          this.registerEventListener(
            document,
            "theme:faq-header-update",
            this.functions.debouncedBuildIndex
          ),
          this.functions.debouncedBuildIndex(),
          this.container.querySelector(".faq-index") &&
            (this.registerEventListener(
              this.container,
              "click",
              this.functions.handleIndexClick.bind(this)
            ),
            this.container
              .closest(".section-faq-header")
              .classList.add(this.classNames.sectionWithIndexStatus),
            this.functions.resizeIndex.call(this),
            this.registerEventListener(
              window,
              "resize",
              theme.debounce(this.functions.resizeIndex.bind(this), 250)
            ));
      }),
        (this.onSectionReorder = function (e) {
          this.functions.debouncedBuildIndex();
        }),
        (this.functions = {
          buildIndex: function e() {
            var t = this.container.closest(".section-faq-header"),
              i = this.container.querySelector(".faq-index__item-container");
            i &&
              i.querySelectorAll(".faq-index-item").forEach((e) => {
                e.parentNode.removeChild(e);
              }),
              (this.linkedCollapsibleTabs = []),
              (this.linkedQuestionContainers = []),
              (this.linkedContent = []);
            for (
              var a = t;
              a.nextElementSibling &&
              a.nextElementSibling.classList.contains(
                "section-collapsible-tabs"
              );

            )
              if (
                ((a = a.nextElementSibling),
                this.linkedCollapsibleTabs.push(a),
                a
                  .querySelectorAll(".collapsible-tabs__tab")
                  .forEach((e) => this.linkedQuestionContainers.push(e)),
                a
                  .querySelectorAll(".collapsible-tabs__content")
                  .forEach((e) => this.linkedContent.push(e)),
                i)
              ) {
                var o = a.querySelector(".collapsible-tabs__heading");
                if (o) {
                  var n = theme.createTemplateVariableEncoder();
                  n.add("title_id", o.id, "attribute"),
                    n.add("title", o.innerHTML, "raw");
                  var s =
                      '\n              <div class="faq-index-item">\n                <a class="faq-index-item__link" href="#'
                        .concat(n.values.title_id, '">')
                        .concat(n.values.title, "</a>\n              </div>"),
                    r = document.createRange().createContextualFragment(s);
                  i.appendChild(r);
                }
              }
            i && this.functions.resizeIndex.call(this);
          },
          resizeIndex: function e() {
            for (
              var t = this.container.querySelector(
                  ".faq-index__sticky-container"
                ),
                i = this.container.closest(".section-faq-header");
              i.nextElementSibling &&
              i.nextElementSibling.classList.contains(
                "section-collapsible-tabs"
              );

            )
              i = i.nextElementSibling;
            var a = t.getBoundingClientRect(),
              o = i.getBoundingClientRect();
            t.style.height = o.bottom - a.top + "px";
          },
          performSearch: function e() {
            setTimeout(() => {
              var e = this.searchInput.value.split(" "),
                t = [];
              e.forEach((e) => {
                e.length > 0 && t.push(e.toLowerCase());
              }),
                this.linkedQuestionContainers.forEach((e) => {
                  if (t.length) {
                    var i = !1,
                      a = e.textContent.toLowerCase();
                    t.forEach((e) => {
                      a.indexOf(e) >= 0 && (i = !0);
                    }),
                      i
                        ? e.classList.remove(
                            this.classNames.questionContainerInactive
                          )
                        : e.classList.add(
                            this.classNames.questionContainerInactive
                          );
                  } else
                    e.classList.remove(
                      this.classNames.questionContainerInactive
                    );
                }),
                this.linkedContent.forEach((e) => {
                  t.length
                    ? e.classList.add(this.classNames.questionContainerInactive)
                    : e.classList.remove(
                        this.classNames.questionContainerInactive
                      );
                });
            }, 10);
          },
          handleIndexClick: function e(t) {
            if (t.target.classList.contains("faq-index-item__link")) {
              t.preventDefault();
              var i = t.target.href.split("#")[1],
                a =
                  document.getElementById(i).getBoundingClientRect().top +
                  window.pageYOffset -
                  50,
                o = getComputedStyle(document.documentElement).getPropertyValue(
                  "--theme-sticky-header-height"
                );
              o && (a -= parseInt(o)),
                window.scrollTo({ top: a, behavior: "smooth" });
            }
          },
        });
    })()),
    cc.sections.push({
      name: "faq-header",
      section: theme.FaqHeader,
      deferredLoad: !1,
    }),
    (theme.CollapsibleTabs = new (function () {
      (this.onSectionLoad = function (e) {
        this.functions.notifyFaqHeaderOfChange();
      }),
        (this.onSectionReorder = function (e) {
          this.functions.notifyFaqHeaderOfChange();
        }),
        (this.onSectionUnload = function (e) {
          this.functions.notifyFaqHeaderOfChange();
        }),
        (this.functions = {
          notifyFaqHeaderOfChange: function e() {
            document.dispatchEvent(
              new CustomEvent("theme:faq-header-update", {
                bubbles: !0,
                cancelable: !1,
              })
            );
          },
        });
    })()),
    cc.sections.push({
      name: "collapsible-tabs",
      section: theme.CollapsibleTabs,
      deferredLoad: !1,
    }),
    (theme.StoreAvailability = function (e) {
      var t = "store-availability-loading",
        i = "store-availability-initialized",
        a = "cc-location";
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.$container = $(e)),
          (this.productId = this.$container.data(
            "store-availability-container"
          )),
          (this.sectionUrl = this.$container.data("section-url")),
          this.$modal,
          this.$container.addClass(i),
          (this.transitionDurationMS =
            1e3 * parseFloat(getComputedStyle(e).transitionDuration)),
          (this.removeFixedHeightTimeout = -1),
          $(window).on(
            "cc-variant-updated".concat(this.namespace).concat(this.productId),
            (e, t) => {
              t.product.id === this.productId &&
                this.functions.updateContent.bind(this)(
                  t.variant ? t.variant.id : null,
                  t.product.title,
                  this.$container.data("has-only-default-variant"),
                  t.variant && void 0 !== t.variant.available
                );
            }
          ),
          this.$container.data("single-variant-id") &&
            this.functions.updateContent.bind(this)(
              this.$container.data("single-variant-id"),
              this.$container.data("single-variant-product-title"),
              this.$container.data("has-only-default-variant"),
              this.$container.data("single-variant-product-available")
            );
      }),
        (this.onSectionUnload = function () {
          $(window).off(
            "cc-variant-updated".concat(this.namespace).concat(this.productId)
          ),
            this.$container.off("click"),
            this.$modal && this.$modal.off("click");
        }),
        (this.functions = {
          getUserLocation: function e() {
            return new Promise((e, t) => {
              var i;
              sessionStorage[a] && (i = JSON.parse(sessionStorage[a])),
                i
                  ? e(i)
                  : navigator.geolocation
                  ? navigator.geolocation.getCurrentPosition(
                      function (t) {
                        var i = {
                          latitude: t.coords.latitude,
                          longitude: t.coords.longitude,
                        };
                        fetch("/localization.json", {
                          method: "PUT",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify(i),
                        }),
                          (sessionStorage[a] = JSON.stringify(i)),
                          e(i);
                      },
                      function () {
                        e(!1);
                      },
                      { maximumAge: 36e5, timeout: 5e3 }
                    )
                  : e(!1);
            });
          },
          getAvailableStores: function e(t, i) {
            return $.get(this.sectionUrl.replace("VARIANT_ID", t), i);
          },
          calculateDistance: function e(t, i, a) {
            var o = Math.PI / 180,
              n = "metric" === a ? 6378.14 : 3959,
              s = t.latitude * o,
              r = t.longitude * o,
              l = i.latitude * o,
              c =
                Math.pow(Math.sin((s - l) / 2), 2) +
                Math.cos(s) *
                  Math.cos(l) *
                  Math.pow(Math.sin((r - i.longitude * o) / 2), 2);
            return n * (2 * Math.atan2(Math.sqrt(c), Math.sqrt(1 - c)));
          },
          updateLocationDistances: function e(t) {
            var i = this.$modal.find("[data-unit-system]").data("unit-system"),
              a = this;
            this.$modal.find('[data-distance="false"]').each(function () {
              var e = {
                latitude: parseFloat($(this).data("latitude")),
                longitude: parseFloat($(this).data("longitude")),
              };
              if (e.latitude && e.longitude) {
                var o = a.functions.calculateDistance(t, e, i).toFixed(1);
                $(this).html(o),
                  setTimeout(() => {
                    $(this)
                      .closest(".store-availability-list__location__distance")
                      .addClass("-in");
                  }, 0);
              }
              $(this).attr("data-distance", "true");
            });
          },
          updateContent: function e(i, a, o, n) {
            this.$container.off(
              "click",
              "[data-store-availability-modal-open]"
            ),
              this.$container.off(
                "click" + this.namespace,
                ".cc-popup-close, .cc-popup-background"
              ),
              $(".store-availabilities-modal").remove(),
              n
                ? (this.$container.addClass(t),
                  this.transitionDurationMS > 0 &&
                    this.$container.css(
                      "height",
                      this.$container.outerHeight() + "px"
                    ))
                : (this.$container.addClass(t),
                  this.transitionDurationMS > 0 &&
                    this.$container.css("height", "0px")),
              n &&
                this.functions.getAvailableStores.call(this, i, (e) => {
                  if (e.trim().length > 0 && !e.includes("NO_PICKUP")) {
                    this.$container.html(e),
                      this.$container.html(
                        this.$container.children().first().html()
                      ),
                      this.$container
                        .find("[data-store-availability-modal-product-title]")
                        .html(a),
                      o &&
                        this.$container
                          .find(".store-availabilities-modal__variant-title")
                          .remove(),
                      this.$container.find(".cc-popup").appendTo("body"),
                      (this.$modal = $("body").find(
                        ".store-availabilities-modal"
                      ));
                    var n = new ccPopup(this.$modal, this.namespace);
                    if (
                      (this.$container.on(
                        "click",
                        "[data-store-availability-modal-open]",
                        () => (
                          n.open(),
                          this.functions.getUserLocation().then((e) => {
                            e &&
                              this.$modal.find('[data-distance="false"]')
                                .length &&
                              this.functions.getAvailableStores.call(
                                this,
                                i,
                                (t) => {
                                  this.$modal
                                    .find(".store-availabilities-list")
                                    .html(
                                      $(t)
                                        .find(".store-availabilities-list")
                                        .html()
                                    ),
                                    this.functions.updateLocationDistances.bind(
                                      this
                                    )(e);
                                }
                              );
                          }),
                          !1
                        )
                      ),
                      this.$modal.on(
                        "click" + this.namespace,
                        ".cc-popup-close, .cc-popup-background",
                        () => {
                          n.close();
                        }
                      ),
                      this.$container.removeClass(t),
                      this.transitionDurationMS > 0)
                    ) {
                      var s = this.$container
                        .find(".store-availability-container")
                        .outerHeight();
                      this.$container.css("height", s > 0 ? s + "px" : ""),
                        clearTimeout(this.removeFixedHeightTimeout),
                        (this.removeFixedHeightTimeout = setTimeout(() => {
                          this.$container.css("height", "");
                        }, this.transitionDurationMS));
                    }
                  }
                });
          },
        }),
        this.onSectionLoad(e);
    }),
    cc.sections.push({
      name: "store-availability",
      section: theme.StoreAvailability,
    }),
    (theme.Popup = new (function () {
      var e = "cc-theme-popup-dismissed";
      (this.onSectionLoad = function (t) {
        (this.namespace = theme.namespaceFromSection(t)),
          (this.$container = $(t)),
          (this.popup = new ccPopup(this.$container, this.namespace));
        var i = this.$container.data("dismiss-for-days"),
          a = this.$container.data("delay-seconds"),
          o = !0,
          n = this.$container.data("test-mode"),
          s = window.localStorage.getItem(e);
        s && (new Date().getTime() - s) / 864e5 < i && (o = !1),
          this.$container.find(".cc-popup-form__response").length &&
            ((o = !0),
            (a = 1),
            this.$container.find(".cc-popup-form__response--success").length &&
              this.functions.popupSetAsDismissed.call(this)),
          document.querySelector(".shopify-challenge__container") && (o = !1),
          (o || n) &&
            setTimeout(() => {
              this.popup.open();
            }, 1e3 * a),
          this.$container.on(
            "click" + this.namespace,
            ".cc-popup-close, .cc-popup-background",
            () => {
              this.popup.close(() => {
                this.functions.popupSetAsDismissed.call(this);
              });
            }
          );
      }),
        (this.onSectionSelect = function () {
          this.popup.open();
        }),
        (this.functions = {
          popupSetAsDismissed: function t() {
            window.localStorage.setItem(e, new Date().getTime());
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace);
        });
    })()),
    cc.sections.push({ name: "newsletter-popup", section: theme.Popup }),
    (theme.owlCarouselEventList =
      "to.owl.carousel next.owl.carousel prev.owl.carousel destroy.owl.carousel initialized.owl.carousel resized.owl.carousel refreshed.owl.carousel"),
    (theme.beforeCarouselLoadEventBlockFix = function (e) {
      $(e).on(theme.owlCarouselEventList, function (e) {
        e.stopPropagation();
      });
    }),
    (theme.beforeCarouselUnloadEventBlockFix = function (e) {
      $(e).off(theme.owlCarouselEventList);
    }),
    (theme.loadCarousels = function (e) {
      return $(".carousel", e).each(function () {
        var e,
          t,
          i = $(this);
        function a() {
          var e = 0;
          return (
            i
              .find(
                i.hasClass("owl-loaded")
                  ? ".owl-item:not(.cloned)"
                  : ".product-block"
              )
              .each(function () {
                e += $(this).outerWidth(!0);
              }),
            e
          );
        }
        i.closest(".collection-slider").on(
          "click.themeCarousel",
          ".prev, .next",
          function (e) {
            e.preventDefault();
            var t = $(this)
              .closest(".collection-slider")
              .find(".owl-carousel")
              .data("owl.carousel");
            $(this).hasClass("prev") ? t.prev() : t.next();
          }
        );
        var o = !$(this).closest(".container--no-max").length;
        if ((i.toggleClass("carousel--fixed-grid-mode", o), o)) {
          var n = parseInt($(this)[0].className.match(/per-row-(.)/)[1]);
          e = {
            margin: 0,
            loop: !1,
            autoWidth: !1,
            items: 5,
            center: !1,
            nav: !1,
            dots: !1,
            responsive: {
              0: { items: n < 4 ? 1 : 2 },
              480: { items: Math.min(2, n - 2) },
              767: { items: n - 1 },
              1e3: { items: n },
            },
          };
        } else e = { margin: 0, loop: (t = a() > i.width()), autoWidth: !0, items: Math.min(i.children().length, 8), center: !0, nav: !1, dots: !1 };
        i.find("[data-src]").each(function () {
          $(this)
            .attr("data-src-temp", $(this).attr("data-src"))
            .removeAttr("data-src");
        }),
          theme.beforeCarouselLoadEventBlockFix(i),
          i.on("initialized.owl.carousel", function () {
            i.find("[data-src-temp]").each(function () {
              $(this)
                .attr("data-src", $(this).attr("data-src-temp"))
                .removeAttr("data-src-temp");
            }),
              i
                .find(
                  '.product-block__image--primary .lazyload--manual, .product-block__image--secondary[data-image-index="1"] .lazyload--manual, .product-block-options__item.lazyload--manual'
                )
                .removeClass("lazyload--manual")
                .addClass("lazyload"),
              theme.ProductBlockManager.loadImages(
                i.closest("[data-section-type]")
              ),
              setTimeout(function () {
                i.data("owl.carousel").invalidate("width"),
                  i.trigger("refresh.owl.carousel");
              }, 10);
          }),
          i.on("initialized.owl.carousel resized.owl.carousel", function (n) {
            if (!o && "resized" == n.type) {
              var s = a() > i.width();
              if (s != t) {
                (e.loop = s),
                  (t = s),
                  $(n.target).data("owl.carousel").destroy(),
                  $(n.target).owlCarousel(e);
                return;
              }
            }
            setTimeout(function () {
              var e = i.find(".owl-stage").width() > i.width();
              if (e) {
                var t = 0;
                i.find(".owl-item").each(function () {
                  t += $(this).outerWidth(!0) + 1;
                }),
                  i
                    .find(".owl-stage")
                    .css({})
                    .removeClass("owl-stage--items-fit");
              } else i.find(".owl-stage").addClass("owl-stage--items-fit").css({});
              i.closest(".collection-slider")
                .find(".prev, .next")
                .toggleClass("owl-btn-disabled", !e);
            }, 10);
          }),
          (theme.carouselInputIncrementer =
            theme.carouselInputIncrementer || 0),
          i
            .on("refreshed.owl.carousel", function () {
              $(".owl-item", this).removeAttr("aria-hidden"),
                $(".owl-item.cloned", this)
                  .attr("aria-hidden", "true")
                  .each(function () {
                    theme.carouselInputIncrementer++;
                    var e = "_" + theme.carouselInputIncrementer;
                    $(this)
                      .find(
                        "form[id]:not([data-id-altered]), :input[id]:not([data-id-altered])"
                      )
                      .each(function () {
                        $(this).attr("id", $(this).attr("id") + e);
                      })
                      .attr("data-id-altered", !0),
                      $(this)
                        .find("label[for]:not([data-id-altered])")
                        .each(function () {
                          $(this).attr("for", $(this).attr("for") + e);
                        })
                        .attr("data-id-altered", !0);
                  });
            })
            .addClass("owl-carousel")
            .owlCarousel(e);
      });
    }),
    (theme.unloadCarousels = function (e) {
      $(".collection-slider", e).off(".themeCarousel"),
        $(".slick-slider", e).slick("unslick"),
        theme.beforeCarouselUnloadEventBlockFix($(".owl-carousel", e)),
        $(".owl-carousel", e).each(function () {
          $(this).data("owl.carousel").destroy();
        });
    }),
    (theme.icons = {
      left:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_left +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
      right:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_right +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
      close:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><title>' +
        theme.strings.icon_labels_close +
        '</title><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
      chevronLeft:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>' +
        theme.strings.icon_labels_left +
        '</title><polyline points="15 18 9 12 15 6"></polyline></svg>',
      chevronRight:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>' +
        theme.strings.icon_labels_right +
        '</title><polyline points="9 18 15 12 9 6"></polyline></svg>',
      chevronDown:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_down +
        '</title><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
      tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
      label:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag"><title>Label</title><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg>',
    });
  try {
    theme.Shopify.features = JSON.parse(
      document.documentElement.querySelector("#shopify-features").textContent
    );
  } catch (e) {
    theme.Shopify.features = {};
  }
  (theme.namespaceFromSection = function (e) {
    return [".", $(e).data("section-type"), $(e).data("section-id")].join("");
  }),
    (theme.toggleLinkDropdownButton = function (e) {
      e.stopPropagation();
      var t = $(e.currentTarget),
        i = "false" == t.attr("aria-expanded");
      t.attr("aria-expanded", i), t.css("width", t.outerWidth() + "px");
      var a = null,
        o = t.next();
      t.closest(".link-dropdown").hasClass("link-dropdown--left-aligned") ||
        (i
          ? ((a = o.outerWidth()),
            (a += parseInt(o.css("right"))),
            (a -= parseInt(
              o.find(".link-dropdown__link:first").css("padding-left")
            )))
          : (a =
              parseInt(t.css("padding-right")) +
              t.find(".link-dropdown__button-text").width() +
              1),
        setTimeout(function () {
          t.css("width", a + "px");
        }, 10));
    }),
    (theme.awakenImagesFromSlumber = function (e) {
      e.find(".lazyload--manual:not(.lazyload)").addClass("lazyload");
    }),
    (theme.measureTextInsideElement = function (e, t) {
      theme.measureTextInsideElementCanvas =
        theme.measureTextInsideElementCanvas ||
        document.createElement("canvas");
      var i = theme.measureTextInsideElementCanvas.getContext("2d"),
        a = getComputedStyle(t).font;
      return (i.font = a), i.measureText(e);
    }),
    (theme.avoidUnecessaryOrphans = function (e) {
      if (theme.settings.avoid_orphans) {
        var t = e.innerText.split(" ");
        if (
          t.length >= 4 &&
          t[t.length - 1].length + t[t.length - 2].length < 20
        ) {
          var i = e.innerHTML;
          if (0 > i.indexOf("&nbsp;")) {
            var a = (i = i.replace(/<[^>]*?>/g, (e) =>
                e.replace(/ /g, "ΩΩ")
              )).split(" "),
              o = a.pop();
            if (
              theme.measureTextInsideElement(
                a[a.length - 1].replace(/<[^>]*?>/g, "") +
                  " " +
                  o.replace(/<[^>]*?>/g, ""),
                e
              ).width > e.clientWidth
            )
              return;
            (i = (i = a.join(" ") + "&nbsp;" + o).replace(/ΩΩ/g, " ")),
              (e.innerHTML = i);
          }
        }
      }
    }),
    (theme.stickyHeaderHeight = function () {
      var e = getComputedStyle(document.documentElement).getPropertyValue(
        "--theme-sticky-header-height"
      );
      return (e && parseInt(e)) || 0;
    }),
    (theme.scrollToRevealElement = function (e) {
      var t = e.getBoundingClientRect().top + window.scrollY,
        i = t + e.offsetHeight,
        a = window.scrollY,
        o = window.scrollY + window.innerHeight - 50;
      (t < a || i > o) &&
        window.scrollTo({
          top: t - 100 - theme.stickyHeaderHeight(),
          left: window.screenLeft,
          behavior: "smooth",
        });
    }),
    (theme.getEmptyOptionSelectors = function (e) {
      var t = [];
      return (
        e
          .find('[data-selector-type="dropdown"].option-selector')
          .each(function () {
            $(this)
              .find('[aria-selected="true"]')
              .filter(function () {
                return this.dataset && this.dataset.value;
              }).length || t.push(this);
          }),
        e
          .find('[data-selector-type="listed"].option-selector')
          .each(function () {
            $(this).find("input:checked").length || t.push(this);
          }),
        t
      );
    }),
    (theme.validateProductForm = function (e) {
      if (
        (e
          .find(".option-selector--empty")
          .removeClass("option-selector--empty")
          .find(".label__prefix")
          .remove(),
        e.find(".original-selector").val())
      )
        return !0;
      var t = theme.getEmptyOptionSelectors(e);
      return (
        t.length &&
          (t.forEach((e) => {
            e.classList.add("option-selector--empty");
            var t = document.createElement("span");
            (t.innerText = theme.strings.products_product_pick_a + " "),
              (t.className = "label__prefix"),
              e.querySelector(".label").prepend(t);
          }),
          theme.scrollToRevealElement(t[0]),
          e.addClass("product-form--validation-started")),
        !1
      );
    }),
    (theme.lazyBGSetWidths = [
      180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450,
      2700, 3e3, 3350, 3750, 4100,
    ]),
    (theme.loadLazyBGSet = function (e) {
      $("[data-lazy-bgset-src]", e).each(function () {
        for (
          var e = "",
            t = $(this).data("lazy-bgset-src"),
            i = $(this).data("lazy-bgset-aspect-ratio"),
            a = $(this).data("lazy-bgset-width"),
            o = Math.round(a / i),
            n = 0;
          n < theme.lazyBGSetWidths.length;
          n++
        ) {
          var s = theme.lazyBGSetWidths[n];
          a >= s &&
            (e += ""
              .concat(theme.Shopify.formatImage(t, s + "x"), " ")
              .concat(s, "w ")
              .concat(Math.round(s / i), "h, "));
        }
        (e += "".concat(t, " ").concat(a, "w ").concat(o, "h")),
          $(this)
            .attr("data-bgset", e)
            .removeClass("lazyload--manual")
            .addClass("lazyload");
      });
    }),
    (theme.applyAjaxToProductForm = function (e) {
      e.find("form.product-purchase-form").each(function () {
        var t = $(this);
        t.on("submit", function (i) {
          if (!theme.validateProductForm(e)) return !1;
          if (
            "drawer" === theme.settings.cart_type &&
            e.is('[data-ajax-add-to-cart="true"]')
          ) {
            i.preventDefault();
            var a = [
                '<div id="cart-summary-overlay" class="cart-summary-overlay">',
                '<div class="cart-summary-overlay__row-head">',
                '<div class="cart-summary-overlay__column-image">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_title,
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-item">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_item,
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-price-region">',
                '<div class="cart-summary-overlay__column-price">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_unit_price,
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-quantity">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_quantity,
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-total">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_total_price,
                "</div>",
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-subtotal">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_subtotal,
                "</div>",
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__row-body">',
                '<div class="cart-summary-overlay__column-image">',
                '<img src="[[image_url]]" alt="[[encoded-title]]" />',
                "</div>",
                '<div class="cart-summary-overlay__column-item">',
                '<div class="cart-summary-overlay__title">[[title]]</div>',
                '<div class="cart-summary-overlay__variants">[[variants]]</div>',
                '<div class="cart-summary-overlay__mobile-price-row">',
                '<div class="cart-summary-overlay__mobile-unit-price">[[unit_price]]</div>',
                '<div class="cart-summary-overlay__mobile-quantity">',
                theme.strings.products_added_notification_quantity,
                '<span class="cart-summary-overlay__quantity">[[quantity]]</span>',
                "</div>",
                '<div class="cart-summary-overlay__mobile-line-price">[[line_price]]</div>',
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-price-region">',
                '<div class="cart-summary-overlay__column-price">',
                '<span class="cart-summary-overlay__unit-price">[[unit_price]]</span>',
                "</div>",
                '<div class="cart-summary-overlay__column-quantity">',
                '<span class="cart-summary-overlay__quantity">[[quantity]]</span>',
                "</div>",
                '<div class="cart-summary-overlay__column-total">',
                '<div class="cart-summary-overlay__line-price">[[line_price]]</div>',
                "</div>",
                "[[line_discount]]",
                "</div>",
                '<div class="cart-summary-overlay__column-subtotal">',
                '<span class="cart-summary-overlay__subtotal">[[subtotal]]</span>',
                '<div class="cart-summary-overlay__note">',
                theme.strings.products_added_notification_shipping_note,
                "&nbsp;</div>",
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__actions">',
                '<a id="shop-more" class="button altcolour" href="#">',
                theme.strings.products_added_notification_keep_shopping,
                "</a>",
                '<a class="button to-cart" href="',
                theme.routes.cart_url,
                '">',
                theme.strings.products_added_notification_cart,
                "</a>",
                "</div>",
                "</div>",
              ].join(""),
              o = theme.routes.cart_add_url + ".js",
              n = theme.routes.cart_url + ".js";
            t
              .find('button[type="submit"]')
              .attr("disabled", "disabled")
              .each(function () {
                $(this).data("previous-value", $(this).val());
              })
              .val(theme.strings.products_product_adding_to_cart),
              $("#cart-summary-overlay #shop-more").triggerHandler("click"),
              $.post(
                o,
                t.serialize(),
                function (e) {
                  document.documentElement.dispatchEvent(
                    new CustomEvent("theme:cartchanged", {
                      bubbles: !0,
                      cancelable: !1,
                    })
                  ),
                    t
                      .find('button[type="submit"]')
                      .removeAttr("disabled")
                      .each(function () {
                        ($btn = $(this))
                          .val(theme.strings.products_product_added_to_cart)
                          .addClass("inverted"),
                          window.setTimeout(function () {
                            $btn
                              .removeClass("inverted")
                              .val($btn.data("previous-value"));
                          }, 3e3);
                      });
                  var i = $.parseJSON(e);
                  $.get(
                    n,
                    function (e) {
                      for (
                        var o = $.parseJSON(e),
                          n = i.quantity,
                          s = i.image,
                          r = theme.OptionManager.getProductData(t),
                          l = i.original_price,
                          c = 0;
                        c < r.variants.length;
                        c++
                      ) {
                        var d = r.variants[c];
                        d.id == i.variant_id &&
                          d.compare_at_price &&
                          d.compare_at_price > l &&
                          (l = d.compare_at_price);
                      }
                      var h = "";
                      if (i.variant_title)
                        for (var c = 0; c < r.options.length; c++)
                          h += [
                            '<div class="cart-summary-overlay__variant">',
                            '<span class="cart-summary-overlay__variant-option">',
                            r.options[c].name,
                            "</span>",
                            '<span class="cart-summary-overlay__variant-value">',
                            i.variant_options[c],
                            "</span>",
                            "</div>",
                          ].join("");
                      i.selling_plan_allocation &&
                        i.selling_plan_allocation.selling_plan.name &&
                        (h += [
                          '<div class="cart-summary-overlay__variant">',
                          '<span class="cart-summary-overlay__variant-value">',
                          i.selling_plan_allocation.selling_plan.name,
                          "</span>",
                          "</div>",
                        ].join("")),
                        t.data("show-preorder-label")
                          ? (h +=
                              '<div class="cart-summary-overlay__price-label price-label price-label--preorder">'.concat(
                                theme.strings.products_product_preorder,
                                "</div>"
                              ))
                          : t.data("show-sale-price-label") &&
                            l > i.original_price &&
                            (h +=
                              '<div class="cart-summary-overlay__price-label price-label price-label--sale">'.concat(
                                theme.strings.products_labels_sale,
                                "</div>"
                              ));
                      var u = "";
                      l > i.final_price &&
                        (u +=
                          '<div class="struck-out-price"><span class="theme-money">' +
                          theme.Shopify.formatMoney(l, theme.money_format) +
                          "</span></div>"),
                        (u +=
                          '<div><span class="theme-money">' +
                          theme.Shopify.formatMoney(
                            i.final_price,
                            theme.money_format
                          ) +
                          "</span></div>"),
                        (u += theme.renderUnitPrice(
                          i.unit_price,
                          i.unit_price_measurement,
                          theme.money_format
                        ));
                      var p = "";
                      l != i.final_price
                        ? ((p +=
                            '<div class="theme-money struck-out-price">' +
                            theme.Shopify.formatMoney(
                              l * n,
                              theme.money_format
                            ) +
                            "</div>"),
                          (p +=
                            '<div class="theme-money">' +
                            theme.Shopify.formatMoney(
                              i.final_line_price,
                              theme.money_format
                            ) +
                            "</div>"))
                        : (p +=
                            '<span class="theme-money">' +
                            theme.Shopify.formatMoney(
                              i.final_line_price,
                              theme.money_format
                            ) +
                            "</span>");
                      var m = "";
                      if (
                        i.line_level_discount_allocations &&
                        i.line_level_discount_allocations.length > 0
                      ) {
                        m += '<ul class="cart-discount-list">';
                        for (
                          var c = 0;
                          c < i.line_level_discount_allocations.length;
                          c++
                        ) {
                          var f = i.line_level_discount_allocations[c];
                          m += [
                            '<li class="cart-discount cart-discount--inline">',
                            '<span class="cart-discount__label">',
                            '<span class="cart-discount__icon">',
                            theme.icons.label,
                            "</span>",
                            '<span class="cart-discount__title">',
                            f.discount_application.title,
                            "</span>",
                            "</span>",
                            '<span class="cart-discount__amount theme-money">',
                            theme.Shopify.formatMoney(
                              f.amount,
                              theme.money_format
                            ),
                            "</span>",
                            "</li>",
                          ].join("");
                        }
                        m += "</ul>";
                      }
                      var g = "";
                      if (
                        o.cart_level_discount_applications &&
                        o.cart_level_discount_applications.length > 0
                      ) {
                        g += '<ul class="cart-discount-list">';
                        for (
                          var c = 0;
                          c < o.cart_level_discount_applications.length;
                          c++
                        ) {
                          var v = o.cart_level_discount_applications[c];
                          g += [
                            '<li class="cart-discount cart-discount--inline">',
                            '<span class="cart-discount__label">',
                            '<span class="cart-discount__icon">',
                            theme.icons.label,
                            "</span>",
                            '<span class="cart-discount__title">',
                            v.title,
                            "</span>",
                            "</span>",
                            '<span class="cart-discount__amount theme-money">',
                            theme.Shopify.formatMoney(
                              v.total_allocated_amount,
                              theme.money_format
                            ),
                            "</span>",
                            "</li>",
                          ].join("");
                        }
                        g += "</ul>";
                      }
                      (g +=
                        '<span class="cart-summary-overlay__subtotal-mobile-title">' +
                        theme.strings.products_added_notification_subtotal +
                        ":</span> "),
                        (g +=
                          '<span class="cart-summary-overlay__subtotal-amount theme-money">' +
                          theme.Shopify.formatMoney(
                            o.total_price,
                            theme.money_format_with_cart_code_preference
                          ) +
                          "</span>");
                      var y = a;
                      y = (y = (y = (y = (y = (y = (y = (y = (y = y.replace(
                        "[[title]]",
                        i.product_title
                      )).replace(
                        "[[encoded-title]]",
                        i.product_title
                          .replace(/"/g, "&quot;")
                          .replace(/&/g, "&amp;")
                      )).replace("[[variants]]", h)).replace(
                        /\[\[quantity\]\]/g,
                        n
                      )).replace(
                        "[[image_url]]",
                        theme.Shopify.formatImage(s, "170x")
                      ))
                        .split("[[unit_price]]")
                        .join(u))
                        .split("[[line_price]]")
                        .join(p))
                        .split("[[line_discount]]")
                        .join(m)).replace("[[subtotal]]", g);
                      var b = $(y);
                      b.find("#shop-more").bind("click", function () {
                        return (
                          b.animate(
                            { top: -b.outerHeight() },
                            500,
                            function () {
                              $(this).remove();
                            }
                          ),
                          !1
                        );
                      }),
                        b
                          .prependTo("body")
                          .css("top", -b.outerHeight())
                          .animate({ top: 0 }, 500);
                    },
                    "html"
                  );
                },
                "text"
              ).fail(function (i) {
                if (
                  (t
                    .find('button[type="submit"]')
                    .removeAttr("disabled")
                    .each(function () {
                      $(this).val($(this).data("previous-value"));
                    }),
                  void 0 !== i && void 0 !== i.status)
                ) {
                  var a = $.parseJSON(i.responseText);
                  theme.showQuickPopup(
                    a.description,
                    t.find('button[type="submit"]:first')
                  );
                } else e.attr("ajax-add-to-cart", "false"), t.submit();
              });
          }
        });
      }),
        "drawer" === theme.settings.cart_type &&
          $(window)
            .off(".ajaxAddScroll")
            .on("scroll.ajaxAddScroll", function () {
              $("#cart-summary-overlay #shop-more").triggerHandler("click");
            });
    }),
    (theme.removeAjaxFromProductForm = function (e) {
      e.find("form.product-purchase-form").off("submit");
    }),
    (theme.LoadFilterer = function (e) {
      if (
        ((this.$container = e.$container),
        (this.namespace = e.namespace),
        (this.registerEventListener = e.registerEventListener),
        (this.functions = {
          initFiltersEtc: function e() {
            $(".filter-container", this.$container).addClass(
              "filter-container--mobile-initialised"
            ),
              location.href.indexOf("?") >= 0 &&
                $(
                  "#sort-dropdown-options .link-dropdown__link",
                  this.$container
                ).each(function () {
                  var e = location.href.split("?")[1].split("&"),
                    t = $(this).attr("href");
                  e.forEach((e) => {
                    -1 === e.indexOf("sort_by=") && (t += "&" + e);
                  }),
                    $(this).attr("href", t);
                }),
              theme.ProductBlockManager.loadImages(this.$container);
          },
          switchGridLayout: function e(t) {
            t.preventDefault(),
              $(t.currentTarget).hasClass("layout-switch--one-column")
                ? this.$container
                    .find(".product-list")
                    .removeClass("product-list--per-row-mob-2")
                    .addClass("product-list--per-row-mob-1")
                : this.$container
                    .find(".product-list")
                    .removeClass("product-list--per-row-mob-1")
                    .addClass("product-list--per-row-mob-2"),
              $(t.currentTarget)
                .addClass("layout-switch--active")
                .siblings()
                .removeClass("layout-switch--active");
          },
          checkStickyScroll: function e() {
            var t = $(".utility-bar").offset().top;
            768 > $(window).width() &&
            this.previousScrollTop > window.scrollY &&
            window.scrollY > t
              ? $("body").addClass("utility-bar-sticky-mobile-copy-reveal")
              : $("body.utility-bar-sticky-mobile-copy-reveal").removeClass(
                  "utility-bar-sticky-mobile-copy-reveal"
                ),
              (this.previousScrollTop = window.scrollY);
          },
          ajaxLoadLink: function e(t) {
            t.preventDefault(),
              this.functions.ajaxLoadUrl.call(
                this,
                $(t.currentTarget).attr("href")
              );
          },
          ajaxLoadForm: function e(t) {
            "submit" === t.type && t.preventDefault();
            var url_par = [];
            var minValElement = document.getElementById("sort-min");
            var maxValElement = document.getElementById("sort-max");

            if (minValElement && maxValElement) {
              var minVal = minValElement.getAttribute("aria-valuenow");
              var maxVal = maxValElement.getAttribute("aria-valuenow");
              var minData = ["filter.v.price.gte", minVal];
              var maxData = ["filter.v.price.lte", maxVal];
              url_par.push(minData);
              url_par.push(maxData);
            } 

            if ( t.currentTarget.classList.value === "CollectionFilterFormPriceOnly") {
              let activeLink = document.getElementById("Filter-filter.p.m.custom.diamond_type-lab");
              console.log(activeLink)
              activeLink.click();
              activeLink.click();
            } else {
                          t.currentTarget.querySelectorAll("input, select").forEach((e) => {
              (("checkbox" !== e.type && "radio" !== e.type) || e.checked) && "" !== e.value && url_par.push([e.name, encodeURIComponent(e.value)]);
            });
            
            var a = location.pathname;
            
            url_par.forEach((e) => {
              a += "&".concat(e[0], "=").concat(e[1]);
            }),
              (a = a.replace("&", "?")),
              this.functions.ajaxLoadUrl.call(this, a);
            }
          },
          // ajaxLoadForm: function (e) {
          //   "submit" === e.type && e.preventDefault();
          //   var formData = [];
          //   e.currentTarget
          //     .querySelectorAll("input, select")
          //     .forEach((input) => {
          //       if (
          //         (input.type !== "checkbox" && input.type !== "radio") ||
          //         input.checked
          //       ) {
          //         if (input.value !== "") {
          //           formData.push([
          //             input.name,
          //             encodeURIComponent(input.value),
          //           ]);
          //         }
          //       }
          //     });

          //   var currentUrl = location.href; // Получаем текущий URL

          //   formData.forEach((data) => {
          //     if (currentUrl.includes("?")) {
          //       currentUrl += "&" + data[0] + "=" + data[1]; // Добавляем новый параметр к существующим
          //     } else {
          //       currentUrl += "?" + data[0] + "=" + data[1]; // Если параметров нет, просто добавляем новый
          //     }
          //   });

          //   this.functions.ajaxLoadUrl.call(this, currentUrl); // Выполняем AJAX-запрос с обновленным URL
          // },

          ajaxPopState: function e(t) {
            this.functions.ajaxLoadUrl.call(this, document.location.href);
          },
          ajaxLoadUrl: function e(t) {
            var i = t;
            "/" === i.slice(0, 1) &&
              (i = window.location.protocol + "//" + window.location.host + i),
              window.history.pushState({ path: i }, "", i);
            var a = "[data-ajax-container]",
              o = this.$container.find(a);
            o.addClass("ajax-loading"),
              this.currentAjaxLoadUrlFetch &&
                this.currentAjaxLoadUrlFetch.abort(),
              (this.currentAjaxLoadUrlFetch = $.get(
                t,
                function (e) {
                  (this.currentAjaxLoadUrlFetch = null),
                    document.activeElement &&
                      (this.activeElementId = document.activeElement.id),
                    theme.ProductBlockManager.unloadImages(this.$container),
                    $("<div>".concat(e, "</div>"))
                      .find(a)
                      .each(function (e) {
                        $(o[e]).html($(this).html());
                      }),
                    this.functions.initFiltersEtc.call(this);
                  var t = this.$container.closest("[data-components]");
                  if (
                    (t.length &&
                      t
                        .data("components")
                        .split(",")
                        .forEach(
                          function (e) {
                            $(document).trigger("cc:component:load", [e, t[0]]);
                          }.bind(this)
                        ),
                    o.removeClass("ajax-loading"),
                    theme.initAnimateOnScroll(),
                    this.activeElementId)
                  ) {
                    var i = document.getElementById(this.activeElementId);
                    i && i.focus();
                  }
                  var n =
                    $("[data-ajax-scroll-to]:first", this.$container).offset()
                      .top - $(".section-header").height();
                  window.scrollTo({ top: n, behavior: "smooth" });
                }.bind(this)
              ));
          },
        }),
        this.$container.data("ajax-filtering")
          ? (this.$container.on(
              "click" + this.namespace,
              ".link-dropdown__link, .filter-group__applied-item, .filter-group__clear-link, .pagination a",
              this.functions.ajaxLoadLink.bind(this)
            ),
            this.$container.on(
              "change" + this.namespace + " submit" + this.namespace,
              "#CollectionFilterForm",
              theme.debounce(this.functions.ajaxLoadForm.bind(this), 700)
            ),
            this.registerEventListener(
              window,
              "popstate",
              this.functions.ajaxPopState.bind(this)
            ))
          : this.$container.on(
              "change" + this.namespace,
              "#CollectionFilterForm",
              function () {
                $(this).submit();
              }
            ),
        this.$container.on(
          "click" + this.namespace,
          ".link-dropdown__button",
          theme.toggleLinkDropdownButton.bind(this)
        ),
        $(document).on("click" + this.namespace, function () {
          $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
        }),
        document.querySelector(".utility-bar"))
      ) {
        var t = $(".utility-bar")
          .clone()
          .addClass("utility-bar--sticky-mobile-copy")
          .removeAttr("data-ajax-container")
          .insertAfter(".utility-bar");
        theme.suffixIds(t[0], "dupe"),
          (this.previousScrollTop = window.scrollY),
          $(window).on(
            "throttled-scroll" + this.namespace,
            this.functions.checkStickyScroll.bind(this)
          ),
          this.$container.on(
            "click" + this.namespace,
            "[data-toggle-filters]",
            function (e) {
              var t = $(".filter-container", this.$container)
                .toggleClass(
                  "filter-container--show-filters-desktop filter-container--show-filters-mobile"
                )
                .hasClass("filter-container--show-filters-desktop");
              return (
                $(
                  ".toggle-btn[data-toggle-filters]",
                  this.$container
                ).toggleClass("toggle-btn--revealed-desktop", t),
                theme.ProductBlockManager.afterImagesResized(),
                $(".slick-slider", this.$container).each(function () {
                  $(this).slick("setPosition");
                }),
                !1
              );
            }.bind(this)
          ),
          this.$container.on(
            "click" + this.namespace,
            ".layout-switch",
            this.functions.switchGridLayout.bind(this)
          );
      }
      this.functions.initFiltersEtc.call(this),
        (this.destroy = function () {
          theme.ProductBlockManager.unloadImages(this.$container),
            theme.destroyProductGallery(this.$container),
            this.$container.off(this.namespace),
            $(window).off(this.namespace),
            $(document).off(this.namespace);
        }.bind(this));
    }),
    (theme.buildGalleryViewer = function (e) {
      for (
        var t = $('<div class="gallery-viewer gallery-viewer--pre-reveal">'),
          i = $('<div class="gallery-viewer__zoom-container">').appendTo(t),
          a = $('<div class="gallery-viewer__thumbs">').appendTo(t),
          o = $('<div class="gallery-viewer__controls">').appendTo(t),
          n =
            ($(
              '<a class="gallery-viewer__button gallery-viewer__close" href="#">'
            )
              .html(e.close)
              .appendTo(o),
            $(
              '<a class="gallery-viewer__button gallery-viewer__prev" href="#">'
            )
              .html(e.prev)
              .appendTo(o),
            $(
              '<a class="gallery-viewer__button gallery-viewer__next" href="#">'
            )
              .html(e.next)
              .appendTo(o),
            null),
          s = -0.001,
          r = 0.003,
          l = 1,
          c = { panX: 0, panY: 0, zoom: 1 },
          d = 0;
        d < e.images.length;
        d++
      ) {
        var h = e.images[d];
        $('<a class="gallery-viewer__thumb" href="#">')
          .data("zoom-url", h.zoomUrl)
          .html(h.thumbTag)
          .appendTo(a);
      }
      1 === e.images.length && t.addClass("gallery-viewer--single-image");
      var u = function e(i, a) {
          var o = n.width() > t.width(),
            s = n.height() > t.height();
          if (o || s) {
            var r = t.width() / 2,
              l = t.height() / 2,
              d = i - r,
              h = a - l,
              u = 0,
              m = 0;
            o && (u = Math.round(-d * ((n.width() - t.width()) / 2 / r))),
              s && (m = Math.round(-h * ((n.height() - t.height()) / 2 / l))),
              (c.panX = u),
              (c.panY = m),
              p(0, 0),
              g();
          }
        },
        p = function e(i, a) {
          c.panX += i;
          var o = (n[0].naturalWidth * c.zoom - t.width()) / 2;
          (o = Math.max(o, 0)),
            (c.panX = Math.min(c.panX, o)),
            (c.panX = Math.max(c.panX, -o)),
            (c.panY += a);
          var s = (n[0].naturalHeight * c.zoom - t.height()) / 2;
          (s = Math.max(s, 0)),
            (c.panY = Math.min(c.panY, s)),
            (c.panY = Math.max(c.panY, -s)),
            g();
        },
        m = function e(t, i, a) {
          (c.panX = t), (c.panY = i), (c.zoom = a), f(0);
        },
        f = function e(i) {
          (c.zoom += i), (c.zoom = Math.min(c.zoom, 1));
          var a = t.width() / n[0].naturalWidth,
            o = t.height() / n[0].naturalHeight;
          (c.zoom = Math.max(c.zoom, Math.min(a, o))), p(0, 0), g();
        },
        g = function e() {
          n.css(
            "transform",
            "translate3d("
              .concat(c.panX, "px, ")
              .concat(c.panY, "px, 0) scale(")
              .concat(c.zoom, ")")
          );
        };
      t.on(
        "click.galleryViewer select.galleryViewer",
        ".gallery-viewer__thumb",
        function (e) {
          e.preventDefault(),
            $(this)
              .addClass("gallery-viewer__thumb--active")
              .siblings(".gallery-viewer__thumb--active")
              .removeClass("gallery-viewer__thumb--active"),
            (n = $(
              '<img class="gallery-viewer__zoom-image" alt="" style="visibility: hidden">'
            ))
              .on("load", function () {
                $(this).off("load"),
                  $(this).css({
                    visibility: "",
                    top: t.height() / 2 - $(this).height() / 2,
                    left: t.width() / 2 - $(this).width() / 2,
                  }),
                  m(0, 0, 1);
              })
              .attr("src", $(this).data("zoom-url")),
            i.html(n);
        }
      );
      var v = { isTracking: !1, lastPinchDistance: 0 },
        y = { isTracking: !1, lastTouchX: 0, lastTouchY: 0 };
      t.on("touchend.galleryViewer", function (e) {
        (v.isTracking = !1), (y.isTracking = !1);
      }),
        t.on("mousemove.galleryViewer touchmove.galleryViewer", function (e) {
          if (
            (e.preventDefault(), "touchmove" === e.type && e.touches.length > 0)
          ) {
            var t = e.touches[0];
            if (
              (y.isTracking
                ? (p(
                    (t.clientX - y.lastTouchX) * l,
                    (t.clientY - y.lastTouchY) * l
                  ),
                  (y.lastTouchX = t.clientX),
                  (y.lastTouchY = t.clientY))
                : ((y.isTracking = !0),
                  (y.lastTouchX = t.clientX),
                  (y.lastTouchY = t.clientY)),
              2 === e.touches.length)
            ) {
              var i = e.touches[1],
                a = Math.sqrt(
                  Math.pow(t.clientX - i.clientX, 2) +
                    Math.pow(t.clientY - i.clientY, 2)
                );
              v.isTracking
                ? (f((a - v.lastPinchDistance) * r), (v.lastPinchDistance = a))
                : ((v.lastPinchDistance = a), (v.isTracking = !0));
            } else v.isTracking = !1;
          } else u(e.clientX, e.clientY);
        }),
        t.on("wheel.galleryViewer", function (e) {
          e.preventDefault(),
            0 != e.originalEvent.deltaY && f(e.originalEvent.deltaY * s);
        }),
        t.on(
          "touchmove.galleryViewer",
          ".gallery-viewer__thumbs",
          function (e) {
            e.stopPropagation();
          }
        ),
        t.on("click.galleryViewer", ".gallery-viewer__next", function (e) {
          e.preventDefault();
          var t = a.find(".gallery-viewer__thumb--active").next();
          0 === t.length && (t = a.find(".gallery-viewer__thumb:first")),
            t.trigger("select");
        }),
        t.on("click.galleryViewer", ".gallery-viewer__prev", function (e) {
          e.preventDefault();
          var t = a.find(".gallery-viewer__thumb--active").prev();
          0 === t.length && (t = a.find(".gallery-viewer__thumb:last")),
            t.trigger("select");
        }),
        t.on("click.galleryViewer", ".gallery-viewer__close", function (e) {
          e.preventDefault(),
            t.off(".galleryViewer"),
            t.addClass("gallery-viewer--transition-out");
          var i = t.css("transition-duration");
          (i = i.indexOf("ms") > -1 ? parseFloat(i) : 1e3 * parseFloat(i)),
            setTimeout(function () {
              t.remove(), $("html").removeClass("gallery-viewer-open");
            }, i);
        }),
        t.on(
          "click.galleryViewer",
          ".gallery-viewer__zoom-container",
          function (e) {
            e.preventDefault(),
              1 == c.zoom ? ((c.zoom = 0), f(0)) : ((c.zoom = 1), f(0));
          }
        ),
        $("html").removeClass("gallery-viewer-open"),
        $(".gallery-viewer").remove(),
        $("html").addClass("gallery-viewer-open"),
        t.appendTo("body");
      var b = 0;
      e.currentImage &&
        e.images.forEach((t, i) => {
          e.currentImage === t.zoomUrl && (b = i);
        }),
        a
          .find(".gallery-viewer__thumb:eq(" + b + ")")
          .trigger("select")
          .focus(),
        setTimeout(function () {
          t.removeClass("gallery-viewer--pre-reveal");
        }, 10);
    }),
    (theme.Navigation = {
      init: function e(t) {
        if (0 != t.nav.length) {
          var i = t.nav,
            a = 250,
            o = $(),
            n = -1,
            s = $('<div class="mobile-navigation-drawer">');
          s.append(i.clone());
          var r = $('<div class="mobile-navigation-drawer__footer">').appendTo(
            s
          );
          r.append(
            $(".announcement-bar .inline-menu")
              .clone()
              .removeClass("desktop-only")
          ),
            r.append(
              $(".announcement-bar .header-disclosures")
                .clone()
                .removeClass("desktop-only")
            ),
            r.append(
              $(".announcement-bar .social-links")
                .clone()
                .removeClass("desktop-only")
            ),
            theme.suffixIds(s[0], "mob"),
            s.insertAfter($("#shopify-section-header")),
            s.on(
              "click",
              ".navigation__tier-1 > .navigation__item > .navigation__children-toggle",
              function (e) {
                e.preventDefault(),
                  $(this)
                    .parent()
                    .addClass("navigation__item--open")
                    .closest(".mobile-navigation-drawer")
                    .addClass("mobile-navigation-drawer--child-open")
                    .find(".mobile-nav-title")
                    .text($(this).siblings(".navigation__link").text()),
                  $(this)
                    .siblings(".navigation__tier-2-container")
                    .css({
                      top:
                        Math.ceil(
                          $(".navigation__mobile-header:last").height() + 1
                        ) + "px",
                    }),
                  this.closest(".mobile-navigation-drawer").scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                  });
              }
            ),
            i.data("mobile-expand-with-entire-link") &&
              s.on(
                "click",
                ".navigation__item--with-children > .navigation__link",
                function (e) {
                  e.preventDefault(),
                    $(this)
                      .siblings(".navigation__children-toggle")
                      .trigger("click");
                }
              ),
            s.on("click", ".mobile-nav-back", function (e) {
              e.preventDefault(),
                $(this)
                  .closest(".mobile-navigation-drawer")
                  .removeClass("mobile-navigation-drawer--child-open")
                  .find(".navigation__tier-1 > .navigation__item--open")
                  .removeClass("navigation__item--open");
            }),
            s.on(
              "click",
              ".navigation__tier-2 > .navigation__item > .navigation__children-toggle",
              function (e) {
                if (
                  (e.preventDefault(),
                  $(this).parent().hasClass("navigation__item--open"))
                )
                  $(this).parent().removeClass("navigation__item--open"),
                    $(this)
                      .siblings(".navigation__tier-3-container")
                      .css("height", "");
                else {
                  $(this).parent().addClass("navigation__item--open");
                  var t = $(this).siblings(".navigation__tier-3-container");
                  t.css("height", t.children().outerHeight());
                }
              }
            ),
            i
              .find(".lazyload--manual")
              .removeClass("lazyload--manual")
              .addClass("lazyload"),
            i.on(
              "mouseenter mouseleave",
              ".navigation__tier-1 > .navigation__item--with-children",
              function (e) {
                var t = $(this);
                if ("mouseenter" == e.type) {
                  clearTimeout(n), clearTimeout(t.data("navCloseTimeoutId"));
                  var i = t.siblings(".navigation__item--show-children");
                  i.not(o).removeClass("navigation__item--show-children"),
                    (o = t);
                  var s = 0 == i.length ? 0 : a,
                    r = setTimeout(function () {
                      t.addClass("navigation__item--show-children")
                        .siblings(".navigation__item--show-children")
                        .removeClass("navigation__item--show-children");
                    }, s);
                  (n = r), t.data("navOpenTimeoutId", r);
                } else
                  clearTimeout(t.data("navOpenTimeoutId")),
                    t.data(
                      "navCloseTimeoutId",
                      setTimeout(function () {
                        t.removeClass("navigation__item--show-children");
                      }, a)
                    );
                t.children("[aria-expanded]").attr(
                  "aria-expanded",
                  "mouseenter" == e.type
                );
              }
            );
          var l = function e(t) {
            if ($(window).width() > 767) {
              if ("touchstart" == t.type)
                $(this).data("touchstartedAt", t.timeStamp);
              else if ("touchend" == t.type) {
                if (t.timeStamp - $(this).data("touchstartedAt") < 1e3)
                  return (
                    $(this).data("touchOpenTriggeredAt", t.timeStamp),
                    $(this).parent().hasClass("navigation__item--show-children")
                      ? $(this).parent().trigger("mouseleave")
                      : ($(
                          ".navigation:first .navigation__item--show-children"
                        ).trigger("mouseleave"),
                        $(this).parent().trigger("mouseenter")),
                    !1
                  );
              } else if (
                "click" == t.type &&
                $(this).data("touchOpenTriggeredAt") &&
                t.timeStamp - $(this).data("touchOpenTriggeredAt") < 1e3
              )
                return !1;
            }
          };
          i.on(
            "touchstart touchend click",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
            l
          );
          var c = function e(t) {
            if (13 == t.which) {
              var i = $(this).parent();
              return (
                i.trigger(
                  i.hasClass("navigation__item--show-children")
                    ? "mouseleave"
                    : "mouseenter"
                ),
                !1
              );
            }
          };
          i.on(
            "keydown",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
            c
          ),
            t.proxyTier1Nav &&
              $(t.proxyTier1Nav)
                .on(
                  "mouseenter mouseleave",
                  ".navigation__tier-1 > .navigation__item--with-children",
                  function (e) {
                    $(
                      $(".navigation__tier-1 > .navigation__item", i)[
                        $(this).index()
                      ]
                    ).trigger(e.type);
                  }
                )
                .on(
                  "touchstart touchend click",
                  ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
                  function (e) {
                    if (
                      !1 ===
                      l.bind(
                        $(
                          $(".navigation__tier-1 > .navigation__item", i)[
                            $(this).parent().index()
                          ]
                        ).children(".navigation__link")[0]
                      )(e)
                    )
                      return !1;
                  }
                )
                .on(
                  "keydown",
                  ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
                  function (e) {
                    if (13 == e.which)
                      return (
                        c.bind(
                          $(
                            $(".navigation__tier-1 > .navigation__item", i)[
                              $(this).parent().index()
                            ]
                          ).children(".navigation__children-toggle")[0]
                        )(e),
                        !1
                      );
                  }
                ),
            i.on(
              "click",
              '.navigation__link[href="#"][aria-haspopup="true"]',
              function () {
                return (
                  $(this)
                    .siblings(".navigation__children-toggle")
                    .trigger("click"),
                  !1
                );
              }
            );
        }
      },
      destroy: function e(t, i) {
        t.add(i).off("click mouseenter mouseleave touchstart touchend keydown"),
          theme.ProductBlockManager.unloadImages(
            $(".mobile-navigation-drawer .product-list")
          ),
          $(".mobile-navigation-drawer").off("click").remove();
      },
    }),
    (theme.ProductBlockManager = new (function () {
      var e = this;
      (e.isDesktop = function () {
        return $(window).width() >= 768;
      }),
        (e.loadImages = function (t) {
          var t = t;
          void 0 === t && (t = $("body")),
            theme.loadLazyBGSet(t),
            e.isDesktop() &&
              (setTimeout(() => {
                $(
                  ".product-block__image--show-on-hover.product-block__image--inactivated",
                  t
                ).each(function () {
                  e.lazyloadImage($(this)),
                    lazySizes.loader.unveil($(this).find(".lazyload")[0]);
                });
              }, 250),
              setTimeout(() => {
                $(
                  ".product-block__image--show-on-hover + .product-block__image--inactivated",
                  t
                ).each(function () {
                  e.lazyloadImage($(this));
                });
              }, 1e3)),
            e.monitorImagePagination(t),
            e.monitorSwatchSelection(t),
            e.afterImagesResized(t);
        }),
        (e.unloadImages = function (e) {
          $(e).off(".productBlockManager");
        }),
        (e.getImageAt = function (e, t) {
          return e[((t % e.length) + e.length) % e.length];
        }),
        (e.lazyloadImage = function (e, t) {
          var i = e.filter(".product-block__image--inactivated");
          i.length
            ? (t &&
                i.on("lazyloaded.themeBlockManager", (e) => {
                  e.target === i.find(".lazyloaded")[0] && t(),
                    $(this).off("lazyloaded.themeBlockManager");
                }),
              i.removeClass("product-block__image--inactivated"))
            : t && t();
        }),
        (e.incrementActiveImage = function (t, i) {
          var a = Math.max(
            t.filter(".product-block__image--active:first").index(),
            0
          );
          e.setActiveImage(t, a + i);
        }),
        (e.setActiveImage = function (t, i) {
          var a = $(e.getImageAt(t, i));
          e.lazyloadImage(a, () => {
            a.addClass("product-block__image--active"),
              a.siblings().removeClass("product-block__image--active");
            var o = $(e.getImageAt(t, i + 1)).addClass(
              "product-block__image--show-on-hover"
            );
            o.siblings().removeClass("product-block__image--show-on-hover"),
              e.lazyloadImage(o);
          }),
            t
              .closest(".image-cont")
              .find(".product-block__image-dot")
              .removeClass("product-block__image-dot--active")
              .eq(a.index())
              .addClass("product-block__image-dot--active");
        }),
        (e.monitorImagePagination = function (t) {
          $(".image-cont--with-secondary-image", t).length &&
            ($(t).on(
              "click.productBlockManager",
              ".image-page-button",
              function (t) {
                var i = $(this)
                  .closest(".product-block")
                  .find(".product-block__image");
                return (
                  e.incrementActiveImage(
                    i,
                    $(t.currentTarget).hasClass("image-page-button--next")
                      ? 1
                      : -1
                  ),
                  i.each(function () {
                    e.lazyloadImage($(this));
                  }),
                  !1
                );
              }
            ),
            0 ===
              $(".image-cont--with-secondary-image:first", t).closest(
                ".carousel, .product-list--scrollarea"
              ).length &&
              ($(t).on("imageSwiped", ".product-block", function () {
                $(".product-block__image--inactivated", this).length &&
                  setTimeout(
                    function () {
                      $(this)
                        .find(".product-block__image")
                        .each(function () {
                          e.lazyloadImage($(this));
                        });
                    }.bind(this),
                    500
                  );
              }),
              $(t).on(
                "touchstart.productBlockManager",
                ".image-cont--with-secondary-image",
                function (t) {
                  (theme.productBlockTouchTracking = !0),
                    (theme.productBlockTouchStartX = t.touches[0].clientX),
                    (theme.productBlockTouchStartY = t.touches[0].clientY);
                  var i = t.currentTarget.querySelector(
                    ".product-block__image--active + .product-block__image--inactivated"
                  );
                  i && e.lazyloadImage($(i));
                }
              ),
              $(t).on(
                "touchmove.productBlockManager",
                ".image-cont--with-secondary-image",
                function (t) {
                  if (
                    theme.productBlockTouchTracking &&
                    30 >
                      Math.abs(
                        t.touches[0].clientY - theme.productBlockTouchStartY
                      )
                  ) {
                    var i =
                      t.touches[0].clientX - theme.productBlockTouchStartX;
                    if (i > 25) {
                      var a = $(this)
                        .closest(".product-block")
                        .trigger("imageSwiped")
                        .find(".product-block__image");
                      e.incrementActiveImage(a, -1),
                        (theme.productBlockTouchTracking = !1);
                    } else if (i < -25) {
                      var a = $(this)
                        .closest(".product-block")
                        .trigger("imageSwiped")
                        .find(".product-block__image");
                      e.incrementActiveImage(a, 1),
                        (theme.productBlockTouchTracking = !1);
                    }
                  }
                }
              ),
              $(t).on(
                "touchend.productBlockManager",
                ".image-cont--with-secondary-image",
                function (e) {
                  theme.productBlockTouchTracking = !1;
                }
              )));
        }),
        (e.monitorSwatchSelection = function (t) {
          $("[data-media].product-block-options__item", t).length &&
            $(t).on(
              "mouseenter.productBlockManager click.productBlockManager",
              "[data-media].product-block-options__item",
              function () {
                var t = $(this)
                    .closest(".product-block")
                    .find(".product-block__image"),
                  i = t
                    .filter(
                      '[data-media-id="' +
                        $(this).data("media") +
                        '"].product-block__image'
                    )
                    .index();
                e.setActiveImage(t, i);
              }
            );
        }),
        (e.afterImagesResized = function (t) {
          var t = t;
          void 0 === t && (t = $("body")), e.alignProductBlockHeights(t);
        }),
        (e.alignProductBlockHeights = function (e) {
          var e = e;
          void 0 === e && (e = $("body")),
            $(".collection-listing .product-list", e).each(function () {
              if (
                $(window).width() >= 768 ||
                $(this).closest(".carousel").length > 0
              ) {
                var e = 0;
                $(this)
                  .find(".product-block .block-inner .block-inner-inner")
                  .each(function () {
                    $(this).height() > e && (e = $(this).height());
                  }),
                  $(this)
                    .find(".product-block .block-inner")
                    .css("min-height", e);
              } else $(this).find(".product-block .block-inner").css("min-height", "");
            });
        });
    })()),
    (theme.initProductGallery = function (e) {
      var t = $(".gallery", e);
      if (!t.hasClass("gallery-initialised")) {
        if (
          (t.addClass("gallery-initialised"),
          t.data("variant-image-grouping") &&
            "" !== t.data("variant-image-grouping-option-index"))
        ) {
          var i = theme.OptionManager.getProductData(
              t.closest(".product-detail").find(".product-form")
            ),
            a = t.data("variant-image-grouping-option-index"),
            o = {};
          i.variants.forEach((e) => {
            e.featured_media &&
              !o[e.options[a]] &&
              (o[e.options[a]] = e.featured_media.id);
          });
          var n = "";
          t.find(".slide, .thumbnail").each(function (e, t) {
            for (var i in o) $(t).data("media-id") == o[i] && (n = i);
            $(t).attr("data-variant-image-group", n);
          });
        }
        var s = $(".product-slideshow", e);
        if (s.length) {
          var r = {
            autoplay: !1,
            fade: !1,
            infinite: !1,
            useTransform: !0,
            dots: !1,
            arrows: !1,
            waitForAnimate: !1,
            appendArrows: s
              .siblings(".slideshow-controls")
              .find(".slideshow-controls__arrows"),
            prevArrow:
              '<button type="button" class="slick-product-prev" aria-label="' +
              theme.strings.previous +
              '">' +
              theme.icons.chevronLeft +
              "</button>",
            nextArrow:
              '<button type="button" class="slick-product-next" aria-label="' +
              theme.strings.next +
              '">' +
              theme.icons.chevronRight +
              "</button>",
            mobileFirst: !0,
            responsive: [
              { breakpoint: 768, settings: { fade: !0, arrows: !0 } },
            ],
          };
          if (
            (s
              .on("init", function (e, t) {
                $(".lazyload--manual", this)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload");
              })
              .on("beforeChange", function (e, t, i, a) {
                var o = $(t.$slides[a]).data("media-id");
                $(
                  $(this)
                    .closest(".gallery")
                    .find(
                      '.thumbnails:not(.hidden) .thumbnail[data-media-id="' +
                        o +
                        '"]'
                    )
                ).trigger("selectFromSlick");
              }),
            s.closest(
              ".gallery--layout-carousel-beside, .gallery--layout-carousel-under"
            ).length)
          )
            s.slick(r);
          else {
            var l = function e() {
              768 > $(window).width()
                ? s.not(".slick-slider").each(function () {
                    $(this)
                      .find(".slide--inactive-option")
                      .removeClass("slide--inactive-option"),
                      $(this).slick(r),
                      $(this)
                        .closest(".product-detail")
                        .find(".original-selector")
                        .trigger("change");
                  })
                : s.filter(".slick-slider").each(function () {
                    $(this).slick("slickUnfilter").slick("unslick"),
                      $(this)
                        .closest(".product-detail")
                        .find(".original-selector")
                        .trigger("change");
                  });
            };
            l(), $(window).on("debouncedresize.productGallery", l);
          }
          theme.ProductMedia.init(t, {
            onPlyrInit: function e(t) {
              s.hasClass("slick-slider") &&
                theme.productGallerySlideshowTabFix(
                  s.slick("getSlick").$slides,
                  s.slick("getSlick").currentSlide
                );
            },
            onYoutubeInit: function e(t) {
              s.hasClass("slick-slider") &&
                theme.productGallerySlideshowTabFix(
                  s.slick("getSlick").$slides,
                  s.slick("getSlick").currentSlide
                );
            },
            onModelViewerInit: function e(t) {
              s.hasClass("slick-slider") &&
                theme.productGallerySlideshowTabFix(
                  s.slick("getSlick").$slides,
                  s.slick("getSlick").currentSlide
                );
            },
            onVideoVisible: function e(t) {
              $(window).width() >= 768 &&
                $(t.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "swipe", !1);
            },
            onVideoHidden: function e(t) {
              $(window).width() >= 768 &&
                $(t.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "swipe", !0);
            },
            onPlyrPlay: function e(t) {
              $(t.target)
                .closest(".slick-slider")
                .slick("slickSetOption", "swipe", !1);
            },
            onPlyrPause: function e(t) {
              $(t.target)
                .closest(".slick-slider")
                .slick("slickSetOption", "swipe", !0);
            },
            onModelViewerPlay: function e(t) {
              $(t.target)
                .closest(".slick-slider")
                .slick("slickSetOption", "swipe", !1),
                $(t.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "accessibility", !1);
            },
            onModelViewerPause: function e(t) {
              $(t.target)
                .closest(".slick-slider")
                .slick("slickSetOption", "swipe", !0),
                $(t.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "accessibility", !0);
            },
          }),
            s.hasClass("slick-slider") &&
              theme.productGallerySlideshowTabFix(
                s.slick("getSlick").$slides,
                s.slick("getSlick").currentSlide
              ),
            s.on("afterChange", function (e, t, i) {
              $(".product-media--activated")
                .removeClass("product-media--activated")
                .trigger("mediaHidden"),
                $(".product-media", t.$slides[i])
                  .addClass("product-media--activated")
                  .trigger("mediaVisible"),
                theme.productGallerySlideshowTabFix(t.$slides, i),
                $(this).closest(".quickbuy-container").trigger("changedsize");
            }),
            $(e).closest(".collection-listing").length > 0 &&
              s.on("afterChange", function () {
                $(this).closest(".quickbuy-container").trigger("changedsize");
              });
        }
        var c = $(".thumbnails:not(.hidden)", e);
        if (c.length) {
          var d = 6,
            h = !1,
            u = function e() {
              "flex" == c.parent().css("display")
                ? h &&
                  ((h = !1),
                  theme.beforeCarouselUnloadEventBlockFix(c),
                  c.removeClass("owl-carousel").data("owl.carousel").destroy(),
                  t
                    .closest(".product-detail")
                    .find(".original-selector")
                    .trigger("change"))
                : h ||
                  ((h = !0),
                  theme.beforeCarouselLoadEventBlockFix(c),
                  c.find(".thumbnail").show(),
                  t.find(".hidden-thumbnails").children().appendTo(c),
                  c
                    .addClass("owl-carousel")
                    .on("initialized.owl.carousel", function () {
                      $(".lazyload--manual", this)
                        .removeClass("lazyload--manual")
                        .addClass("lazyload");
                    })
                    .owlCarousel({ items: d, dots: !1, margin: 7 }),
                  t
                    .closest(".product-detail")
                    .find(".original-selector")
                    .trigger("change"));
            };
          $(window).on("debouncedresize.productGallery", u),
            u(),
            $(e).data("assessCarouselCallback", u),
            $(".gallery", e).on(
              "click select selectFromSlick",
              ".thumbnails.owl-carousel .thumbnail",
              function (e) {
                e.preventDefault();
                var t = $(this).parent();
                if ("selectFromSlick" != e.type) {
                  var i = $(this).data("media-id"),
                    a = $(this)
                      .closest(".gallery")
                      .find(".slideshow.slick-slider");
                  if (a) {
                    var o = a.find('.slide[data-media-id="' + i + '"]').index();
                    a.slick("getSlick").currentSlide === o
                      ? $(this).trigger("selectFromSlick")
                      : a.slick("slickGoTo", o);
                  }
                } else {
                  $(this)
                    .addClass("selected")
                    .parent()
                    .siblings()
                    .find("a")
                    .removeClass("selected");
                  var n = t.parent().children(".active:first").index(),
                    s = n + d - 1,
                    r = t.index();
                  r < n
                    ? t.closest(".owl-carousel").trigger("to.owl.carousel", r)
                    : r > s &&
                      t
                        .closest(".owl-carousel")
                        .trigger("to.owl.carousel", Math.max(0, r - d + 1));
                }
              }
            ),
            $(".gallery", e).on(
              "click select selectFromSlick",
              " .thumbnails:not(.owl-carousel) .thumbnail",
              function (e) {
                if ((e.preventDefault(), "selectFromSlick" != e.type)) {
                  var t = 0,
                    i = $(this).data("media-id");
                  $(this)
                    .parent()
                    .children(":visible")
                    .each(function (e) {
                      if (((t = e), $(this).data("media-id") == i)) return !1;
                    });
                  var a = $(this).closest(".gallery").find(".slideshow");
                  a.slick("getSlick").currentSlide === t
                    ? $(this).trigger("selectFromSlick")
                    : a.slick("slickGoTo", t);
                } else
                  $(this)
                    .addClass("selected")
                    .siblings(".selected")
                    .removeClass("selected");
              }
            );
        }
      }
    }),
    (theme.destroyProductGallery = function (e) {
      $(window).off(".productGallery");
      var t = $(".gallery", e).off("click select selectFromSlick");
      theme.ProductMedia.destroy(t),
        $(".slick-slider", e)
          .slick("unslick")
          .off("init beforeChange afterChange"),
        $(".owl-carousel", e).each(function () {
          theme.beforeCarouselUnloadEventBlockFix(this),
            $(this).data("owl.carousel").destroy();
        });
    }),
    (theme.ProductMedia = new (function () {
      var e = this;
      (e._setupShopifyXr = function () {
        if (!window.ShopifyXR) {
          document.addEventListener(
            "shopify_xr_initialized",
            e._setupShopifyXr.bind(this)
          );
          return;
        }
        window.ShopifyXR.addModels(JSON.parse($(this).html())),
          window.ShopifyXR.setupXRElements();
      }),
        (this.init = function (t, i) {
          var i = i || {},
            a = t;
          $(t)
            .find(".product-media--video")
            .each(function (e) {
              var t = $(this).data("enable-video-looping"),
                a = $(this).find("iframe, video")[0];
              if ("VIDEO" === a.tagName)
                window.Shopify.loadFeatures([
                  {
                    name: "video-ui",
                    version: "1.0",
                    onLoad: function () {
                      var e = { playerType: "html5", element: a };
                      (e.play = function () {
                        this.plyr.play();
                      }.bind(e)),
                        (e.pause = function () {
                          this.plyr.pause();
                        }.bind(e)),
                        (e.destroy = function () {
                          this.plyr.destroy();
                        }.bind(e)),
                        (e.plyr = new Shopify.Plyr(a, {
                          controls: [
                            "play",
                            "progress",
                            "mute",
                            "volume",
                            "play-large",
                            "fullscreen",
                          ],
                          loop: { active: t },
                          hideControlsOnPause: !0,
                          iconUrl:
                            "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                          tooltips: { controls: !1, seek: !0 },
                        })),
                        $(this)
                          .data("player", e)
                          .addClass("product-media--video-loaded"),
                        i.onPlyrPlay && $(a).on("playing", i.onPlyrPlay),
                        i.onPlyrPause && $(a).on("pause ended", i.onPlyrPause),
                        i.onPlyrInit && i.onPlyrInit(e);
                    }.bind(this),
                  },
                ]),
                  theme.loadStyleOnce(
                    "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"
                  );
              else if ("IFRAME" === a.tagName) {
                if (
                  /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                    a.src
                  )
                ) {
                  var o = window.onYouTubeIframeAPIReady,
                    n = function () {
                      var e = { playerType: "youtube", element: a },
                        o = $(this).data("video-id");
                      (e.player = new YT.Player(a, {
                        videoId: o,
                        events: {
                          onStateChange: function e(i) {
                            i.data === YT.PlayerState.ENDED &&
                              t &&
                              i.target.seekTo(0);
                          },
                        },
                      })),
                        (e.play = function () {
                          this.player.playVideo();
                        }.bind(e)),
                        (e.pause = function () {
                          this.player.pauseVideo();
                        }.bind(e)),
                        (e.destroy = function () {
                          this.player.destroy();
                        }.bind(e)),
                        $(this)
                          .data("player", e)
                          .addClass("product-media--video-loaded"),
                        i.onYouTubeInit && i.onYouTubeInit(e);
                    }.bind(this);
                  (window.onYouTubeIframeAPIReady = function () {
                    o(), n();
                  }),
                    theme.loadScriptOnce("https://www.youtube.com/iframe_api");
                } else
                  /vimeo\.com/.test(a.src) &&
                    theme.loadScriptOnce(
                      "https://player.vimeo.com/api/player.js",
                      function () {
                        t && (a.src = a.src + "&loop=1"),
                          (playerObj = {
                            playerType: "vimeo",
                            element: a,
                            player: new Vimeo.Player(a),
                            play: function e() {
                              this.player.play();
                            },
                            pause: function e() {
                              this.player.pause();
                            },
                            destroy: function e() {
                              this.player.destroy();
                            },
                          }),
                          $(this)
                            .data("player", playerObj)
                            .addClass("product-media--video-loaded");
                      }
                    );
              }
            }),
            $(t).on(
              "mediaVisible",
              ".product-media--video-loaded, .product-media--model-loaded",
              function () {
                $(window).width() >= 768 && $(this).data("player").play(),
                  $(this).hasClass("product-media--model") &&
                    $(".view-in-space", a).attr(
                      "data-shopify-model3d-id",
                      $(this).data("model-id")
                    );
              }
            ),
            $(t).on(
              "mediaHidden",
              ".product-media--video-loaded, .product-media--model-loaded",
              function () {
                $(this).data("player").pause();
              }
            ),
            i.onVideoVisible &&
              $(t).on(
                "mediaVisible",
                ".product-media--video-loaded",
                i.onVideoVisible
              ),
            i.onVideoHidden &&
              $(t).on(
                "mediaHidden",
                ".product-media--video-loaded",
                i.onVideoHidden
              ),
            $("model-viewer", t).each(function () {
              i.onModelViewerPlay &&
                $(this).on(
                  "shopify_model_viewer_ui_toggle_play",
                  i.onModelViewerPlay
                ),
                i.onModelViewerPause &&
                  $(this).on(
                    "shopify_model_viewer_ui_toggle_pause",
                    i.onModelViewerPause
                  );
            }),
            $(t).on(
              "mediaVisible mediaVisibleInitial",
              ".product-media--model:not(.product-media--model-loaded)",
              function (e) {
                var t = $(this).find("model-viewer")[0],
                  a = "mediaVisibleInitial" != e.type;
                theme.loadStyleOnce(
                  "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"
                ),
                  window.Shopify.loadFeatures([
                    {
                      name: "model-viewer-ui",
                      version: "1.0",
                      onLoad: function () {
                        $(this).data("player", new Shopify.ModelViewerUI(t)),
                          $(this).addClass("product-media--model-loaded"),
                          i.onModelViewerInit && i.onModelViewerInit(t),
                          a && $(this).trigger("mediaVisible");
                      }.bind(this),
                    },
                  ]);
              }
            ),
            $(".model-json", t).length &&
              window.Shopify.loadFeatures([
                {
                  name: "shopify-xr",
                  version: "1.0",
                  onLoad: e._setupShopifyXr.bind($(".model-json", t)),
                },
              ]),
            $(document).on("shopify_xr_launch", function () {
              $(".product-media--video-loaded").each(function () {
                $(this).data("player").pause();
              });
            }),
            setTimeout(
              function () {
                $(".product-slideshow.slick-slider .product-media:first", this)
                  .filter(".product-media--model")
                  .trigger("mediaVisibleInitial"),
                  $(
                    ".product-slideshow:not(.slick-slider) .product-media--model",
                    this
                  ).trigger("mediaVisibleInitial");
              }.bind(t),
              50
            );
        }),
        (this.destroy = function (e) {
          $(document).off("shopify_xr_launch"),
            $(e).off("mediaVisible mediaVisibleInitial mediaHidden"),
            $(
              ".product-media--video-loaded, .product-media--model-loaded",
              e
            ).each(function () {
              $(this).data("player").destroy();
            }),
            $(".product-media--video video", e).off("playing pause ended"),
            $("model-viewer", e).off(
              "shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause"
            );
        });
    })()),
    (theme.productGallerySlideshowTabFix = function (e, t) {
      $(e[t])
        .find(
          "a, input, button, select, iframe, video, model-viewer, [tabindex]"
        )
        .each(function () {
          void 0 !== $(this).data("theme-slideshow-original-tabindex")
            ? !1 === $(this).data("theme-slideshow-original-tabindex")
              ? $(this).removeAttr("tabindex")
              : $(this).attr(
                  "tabindex",
                  $(this).data("theme-slideshow-original-tabindex")
                )
            : $(this).removeAttr("tabindex");
        }),
        $(e)
          .not(e[t])
          .find(
            "a, input, button, select, iframe, video, model-viewer, [tabindex]"
          )
          .each(function () {
            void 0 === $(this).data("theme-slideshow-original-tabindex") &&
              ($(this).data(
                "theme-slideshow-original-tabindex",
                void 0 !== $(this).attr("tabindex") && $(this).attr("tabindex")
              ),
              $(this).attr("tabindex", "-1"));
          });
    }),
    (theme.productData = {}),
    (theme.OptionManager = new (function () {
      var e = this;
      (e._getVariantOptionElement = function (e, t) {
        return t.find(
          'select[name="id"] option[value="' + (e ? e.id : "") + '"]'
        );
      }),
        (e.selectors = {
          container: ".product-detail",
          gallery: ".gallery",
          priceArea: ".price-area",
          variantIdInputs: '[name="id"]',
          purchaseForm: ".product-purchase-form",
          primaryVariantIdInput: '.product-purchase-form [name="id"]',
          submitButton: 'input[type="submit"], button[type="submit"]',
          multiOption: ".option-selectors",
          customOption: ".custom-option",
          installmentsFormSuffix: "-installments",
        }),
        (e.strings = {
          buttonDefault: theme.strings.products_product_add_to_cart,
          buttonNoStock: theme.strings.products_variant_no_stock,
          buttonNoVariant: theme.strings.products_variant_non_existent,
          unitPriceSeparator:
            theme.strings.products_product_unit_price_separator,
        }),
        (e._getString = function (t, i) {
          var a = e.strings[t];
          return (
            i &&
              (a = a.replace(
                "[PRICE]",
                '<span class="theme-money">' +
                  theme.Shopify.formatMoney(
                    i.price,
                    theme.money_format_with_product_code_preference
                  ) +
                  "</span>"
              )),
            a
          );
        }),
        (e.getProductData = function (e) {
          var t = e.data("product-id"),
            i = null;
          return (
            theme.productData[t] ||
              (theme.productData[t] = JSON.parse(
                document.getElementById("ProductJson-" + t).innerHTML
              )),
            (i = theme.productData[t]) ||
              console.log(
                "Product data missing (id: " + e.data("product-id") + ")"
              ),
            i
          );
        }),
        (e.getBaseUnit = function (e) {
          return 1 === e.unit_price_measurement.reference_value
            ? e.unit_price_measurement.reference_unit
            : e.unit_price_measurement.reference_value +
                e.unit_price_measurement.reference_unit;
        }),
        (e.addVariantUrlToHistory = function (e) {
          if (e) {
            var t =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              e.id;
            window.history.replaceState({ path: t }, "", t);
          }
        }),
        (e.updateSku = function (e, t) {
          t.find(".sku .sku__value").html(e ? e.sku : ""),
            t.find(".sku").toggleClass("sku--no-sku", !e || !e.sku);
        }),
        (e.updateBarcode = function (e, t) {
          t.find(".barcode .barcode__value").html(e ? e.barcode : ""),
            t
              .find(".barcode")
              .toggleClass("barcode--no-barcode", !e || !e.barcode);
        }),
        (e.updateTransferNotice = function (t, i) {
          var a = e._getVariantOptionElement(t, i).data("inventory-transfer");
          a
            ? i
                .find(".product-inventory-transfer")
                .removeClass("product-inventory-transfer--none")
                .html(a)
            : i
                .find(".product-inventory-transfer")
                .addClass("product-inventory-transfer--none")
                .empty();
        }),
        (e.updateVariantDeterminedVisibilityAreas = function (e, t) {
          t.find(".variant-visibility-area").each(function () {
            $(this).children(":not(script)").remove(),
              e &&
                $(this).append(
                  $(this)
                    .children('script[data-variant-id="' + e.id + '"]')
                    .html()
                );
          });
        }),
        (e.updateBackorder = function (t, i) {
          var a = i.find(".backorder");
          if (a.length) {
            if (t && t.available) {
              if (
                t.inventory_management &&
                "out" == e._getVariantOptionElement(t, i).data("stock")
              ) {
                var o = e.getProductData(a.closest(".product-form"));
                a
                  .find(".backorder__variant")
                  .html(
                    o.title +
                      (t.title.indexOf("Default") >= 0 ? "" : " - " + t.title)
                  ),
                  a.show();
              } else a.hide();
            } else a.hide();
          }
        }),
        (e.updatePrice = function (t, i) {
          var a = i.find(e.selectors.priceArea);
          a.removeClass("on-sale");
          var o = $("<div>"),
            n = $('<div class="price h4-style">').appendTo(o);
          if (t) {
            if (
              ($('<span class="current-price theme-money">')
                .html(
                  theme.Shopify.formatMoney(
                    t.price,
                    theme.money_format_with_product_code_preference
                  )
                )
                .appendTo(n),
              t.compare_at_price > t.price &&
                (n.append(" "),
                $('<span class="was-price theme-money">')
                  .html(
                    theme.Shopify.formatMoney(
                      t.compare_at_price,
                      theme.money_format
                    )
                  )
                  .appendTo(n),
                n.addClass("on-sale")),
              t.unit_price_measurement)
            ) {
              var s = $('<div class="unit-price">').appendTo(o);
              $('<span class="unit-price__price theme-money">')
                .html(
                  theme.Shopify.formatMoney(t.unit_price, theme.money_format)
                )
                .appendTo(s),
                $('<span class="unit-price__separator">')
                  .html(e._getString("unitPriceSeparator"))
                  .appendTo(s),
                $('<span class="unit-price__unit">')
                  .html(e.getBaseUnit(t))
                  .appendTo(s);
            }
          } else {
            for (
              var r = e.getProductData(i.find(".product-form:first")),
                l = r.variants[0],
                c = !1,
                d = 0;
              d < r.variants.length;
              d++
            ) {
              var h = r.variants[d];
              h.price < l.price && (l = h), h.price !== l.v && (c = !0);
            }
            c &&
              ($('<span class="price__from">')
                .html(theme.strings.products_listing_from)
                .appendTo(n),
              n.append(" ")),
              $('<span class="current-price theme-money">')
                .html(
                  theme.Shopify.formatMoney(
                    l.price,
                    theme.money_format_with_product_code_preference
                  )
                )
                .appendTo(n),
              l.compare_at_price > l.price &&
                (n.addClass("on-sale").append(" "),
                $('<span class="was-price theme-money">')
                  .html(
                    theme.Shopify.formatMoney(
                      l.compare_at_price,
                      theme.money_format
                    )
                  )
                  .appendTo(n));
          }
          a.html(o.html());
        }),
        (e._updateButtonText = function (t, i, a) {
          t.each(function () {
            var t;
            !1 !== (t = e._getString("button" + i, a)) &&
              ($(this).is("input") ? $(this).val(t) : $(this).html(t));
          });
        }),
        (e.updateButtons = function (t, i) {
          var a = i.find(e.selectors.submitButton);
          t
            ? (a.removeAttr("disabled"),
              !0 == t.available
                ? e._updateButtonText(a, "Default", t)
                : e._updateButtonText(a, "NoStock", t))
            : theme.getEmptyOptionSelectors(i).length
            ? (a.removeAttr("disabled"), e._updateButtonText(a, "Default", t))
            : (a.attr("disabled", "disabled"),
              e._updateButtonText(a, "NoVariant", t));
        }),
        (e.updateContainerStatusClasses = function (t, i) {
          i.toggleClass("variant-status--not-selected", !t),
            i.toggleClass("variant-status--unavailable", t && !t.available),
            i.toggleClass(
              "variant-status--backorder",
              t &&
                t.available &&
                t.inventory_management &&
                "out" == e._getVariantOptionElement(t, i).data("stock")
            ),
            i.toggleClass(
              "variant-status--on-sale",
              t && t.available && t.compare_at_price > t.price
            );
        }),
        (e.initProductOptions = function (t) {
          if (!t.hasClass("theme-init")) {
            var i = e.getProductData(t);
            t.addClass("theme-init"),
              t
                .find(e.selectors.multiOption)
                .on("change.themeProductOptions", function () {
                  var a = [];
                  $(this)
                    .find(".option-selector")
                    .each(function () {
                      "listed" === $(this).data("selector-type")
                        ? a.push($(this).find(".js-option:checked").val())
                        : a.push(
                            $(this)
                              .find('.js-option[aria-selected="true"]')
                              .data("value")
                          );
                    });
                  for (var o = !1, n = 0; n < i.variants.length; n++) {
                    for (var s = i.variants[n], r = 0, l = 0; l < a.length; l++)
                      s.options[l] == a[l] && r++;
                    if (r == a.length) {
                      o = s;
                      break;
                    }
                  }
                  t.find(e.selectors.variantIdInputs).val(o.id),
                    t.find(e.selectors.variantIdInputs).each(function () {
                      this.dispatchEvent(
                        new CustomEvent("change", {
                          bubbles: !0,
                          cancelable: !1,
                          detail: o,
                        })
                      );
                    });
                }),
              t
                .find(e.selectors.customOption)
                .each(function () {
                  var i = $(this).find("input:first, textarea, select");
                  $('<input type="hidden">')
                    .attr({ name: i.attr("name"), value: i.val() })
                    .appendTo(t.find(e.selectors.purchaseForm));
                })
                .on("change.themeProductOptions", function () {
                  var i = $(this).find('input[type="radio"]'),
                    a = $(this).find('input[type="checkbox"]');
                  if (i.length)
                    t.find(e.selectors.purchaseForm + " input")
                      .filter(function () {
                        return this.name === i[0].name;
                      })
                      .val(i.filter(":checked").val())
                      .trigger("change");
                  else if (a.length) {
                    var o = null;
                    (o = a.is(":checked")
                      ? a.val()
                      : a.siblings('[type="hidden"]').val()),
                      t
                        .find(e.selectors.purchaseForm + " input")
                        .filter(function () {
                          return this.name === a[0].name;
                        })
                        .val(o)
                        .trigger("change");
                  } else {
                    var n = $(this).find("select, input, textarea");
                    t.find(e.selectors.purchaseForm + " input")
                      .filter(function () {
                        return this.name === n.attr("name");
                      })
                      .val(n.val())
                      .trigger("change");
                  }
                }),
              t.find(e.selectors.primaryVariantIdInput).each(function () {
                $(this).on(
                  "change.themeProductOptions firstrun.themeProductOptions",
                  function (a) {
                    if (!$(this).is("input[type=radio]:not(:checked)")) {
                      var o = a.detail;
                      if (!o && !1 !== o)
                        for (var n = 0; n < i.variants.length; n++)
                          i.variants[n].id == $(this).val() &&
                            (o = i.variants[n]);
                      var s = $(this).closest(e.selectors.container),
                        r = s
                          .find(e.selectors.submitButton)
                          .filter("[data-add-to-cart-text]");
                      r.length &&
                        (e.strings.buttonDefault = r.data("add-to-cart-text")),
                        e.updatePrice(o, s),
                        e.updateButtons(o, s),
                        $(window).trigger("cc-variant-updated", {
                          variant: o,
                          product: i,
                        }),
                        o &&
                          o.featured_media &&
                          s
                            .find(e.selectors.gallery)
                            .trigger("variantImageSelected", [
                              o,
                              "firstrun" === a.type,
                            ]),
                        e.updateBarcode(o, s),
                        e.updateSku(o, s),
                        e.updateTransferNotice(o, s),
                        e.updateVariantDeterminedVisibilityAreas(o, s),
                        e.updateBackorder(o, s),
                        e.updateContainerStatusClasses(o, s),
                        t.data("enable-history-state") &&
                          "change" == a.type &&
                          e.addVariantUrlToHistory(o),
                        t.trigger("variantChanged", [o, i]);
                    }
                  }
                ),
                  $(this).trigger("firstrun");
              }),
              theme.applyAjaxToProductForm(t);
          }
        }),
        (e.unloadProductOptions = function (t) {
          t.removeClass("theme-init").each(function () {
            $(this).trigger("unloading").off(".themeProductOptions"),
              $(this).find(e.selectors.multiOption).off(".themeProductOptions"),
              $(this)
                .find(e.selectors.customOption)
                .off(".themeProductOptions"),
              theme.removeAjaxFromProductForm(t);
          });
        });
    })()),
    (theme.loadQuickbuy = function () {
      function e(e, t) {
        e.length > 0 &&
          (e.removeClass("expanded"),
          e
            .find(".quickbuy-container")
            .stop()
            .animate({ height: 0 }, t, function () {
              $(this).find(".inner").empty();
            }),
          e.stop().each(function () {
            $(this).animate({ paddingBottom: 0 }, t);
          }));
      }
      function t(e) {
        $(e)
          .closest("[data-components]")
          .each(function () {
            $(this)
              .data("components")
              .split(",")
              .forEach((t) => {
                $(document).trigger("cc:component:load", [t, e]);
              });
          }),
          $(e)
            .find(".cc-accordion")
            .on("transitionend.qbLoadComponents", function () {
              $(this).closest(".quickbuy-container").trigger("changedsize");
            }),
          $(document).trigger("cc:component:load", [
            "custom-select",
            ".quickbuy-container",
          ]);
      }
      function i(e) {
        $(e).find(".cc-accordion").off(".qbLoadComponents"),
          $(e)
            .closest("[data-components]")
            .each(function () {
              $(this)
                .data("components")
                .split(",")
                .forEach((t) => {
                  $(document).trigger("cc:component:unload", [t, e]);
                });
            });
      }
      var a = 500;
      function o() {
        $(".collection-listing").each(function () {
          var e = $(this).find(".product-block");
          if (e.length <= 1) return !0;
          var t = 0,
            i = 0,
            a = Math.min(e.first().outerHeight(), $(e[1]).outerHeight()),
            o = e.first().offset().top;
          e.each(function (e) {
            var n = $(this).offset().top;
            0 == e ? (i = n) : n > i && (t++, (i = n)),
              $(this).data({ offsetTop: o + t * a });
          });
        });
      }
      $(document).on(
        "click",
        ".product-list .product-block:not(.collection-block):not(.main-search-result) .quickbuy-toggle",
        function () {
          var n = $(window).width(),
            s = $(this).attr("href");
          if (n > 767) {
            theme.currentQuickbuyRequest &&
              theme.currentQuickbuyRequest.abort();
            var r = $(this).closest(".product-block"),
              l = null,
              c = null,
              d = $(this).closest(".collection-slider"),
              h = null;
            if (d.length > 0) {
              if (
                0 ===
                (h = d.closest(".collection-slider-row")).find(
                  ".quickbuy-container"
                ).length
              )
                return;
              c = h.find(".quickbuy-container");
            } else c = r.find(".quickbuy-container");
            if (
              ((l = c.find(".inner")),
              r.toggleClass("expanded").hasClass("expanded"))
            ) {
              if (d.length > 0)
                0 ===
                d.find(".product-block.expanded").not(r).removeClass("expanded")
                  .length
                  ? c.height(0)
                  : ($(".product-form", c).trigger("unload-product-form"),
                    $(".gallery", c).off(this.namespace),
                    $(".slideshow", c).slick("unslick"),
                    i(c)),
                  c.off("changedsize").on("changedsize", function () {
                    c.stop().animate({ height: l.outerHeight() }, a);
                  });
              else {
                var u = r.siblings(".expanded");
                u.each(function () {
                  e($(this), 0),
                    $(".product-form", this).trigger("unload-product-form"),
                    theme.destroyProductGallery(this),
                    i(this);
                }),
                  c.off("changedsize").on("changedsize", function () {
                    if (r.hasClass("expanded")) {
                      var e = l.outerHeight(),
                        t = u.length > 0 ? 0 : a;
                      r.stop().animate({ paddingBottom: e + 20 }, t),
                        c.stop().animate({ height: e }, t);
                    }
                  });
              }
              l.html('<div class="loading-spinner"></div>'),
                c.trigger("changedsize");
              var p = $(this).attr("href");
              (theme.currentQuickbuyRequest = $.get(p, function (e) {
                var i = $("<div>" + e + "</div>").find(".quickbuy-content");
                i.find(".more").attr("href", s),
                  i.find(".detail .title").wrapInner($("<a>").attr("href", s)),
                  i
                    .find(".show-gallery")
                    .removeClass("show-gallery")
                    .attr("href", s),
                  i.find(".not-in-quickbuy").remove(),
                  i.find(".only-in-quickbuy").removeClass("only-in-quickbuy"),
                  i
                    .find(".sticky-content-container")
                    .removeClass("sticky-content-container"),
                  i.find(".store-availability-container").remove(),
                  i
                    .find('[data-enable-history-state="true"]')
                    .attr("data-enable-history-state", "false"),
                  i
                    .find(".gallery .thumbnails")
                    .removeClass("mobile-only-important"),
                  [
                    "gallery--layout-carousel-beside",
                    "gallery--layout-columns-1",
                    "gallery--layout-columns-2",
                    "gallery--layout-collage-1",
                    "gallery--layout-collage-2",
                  ].forEach((e) => {
                    i.find("." + e)
                      .removeClass(e)
                      .addClass("gallery--layout-carousel-under");
                  }),
                  i.find(".rte img").on("load", function () {
                    c.trigger("changedsize"), $(this).off("load");
                  }),
                  l.html(i),
                  theme.initProductGallery(c),
                  c
                    .find(".product-form")
                    .trigger("load-product-form")
                    .on("variantChanged", function () {
                      c.trigger("changedsize");
                    }),
                  t(c),
                  theme.initAnimateOnScroll(),
                  c.trigger("changedsize");
              }).always(function () {
                theme.currentQuickbuyRequest = !1;
              })),
                c.find(".close-detail").removeAttr("tabindex");
              var m = "qb",
                f = -120;
              if (
                ("sticky" == $(".section-header").css("position") &&
                  (f -= $(".section-header").height()),
                "qb" == m)
              )
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: c.offset().top + f },
                  500
                );
              else if (d.length > 0)
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: r.offset().top },
                  500
                );
              else {
                o();
                var g =
                  void 0 !== r.data("offsetTop")
                    ? r.data("offsetTop")
                    : r.offset().top;
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: g + f },
                  500
                );
              }
            } else {
              i(c),
                d.length > 0
                  ? c.stop().animate({ height: 0 }, a, function () {
                      l.empty();
                    })
                  : e(r, a);
              var v = -140;
              $("html:not(:animated),body:not(:animated)").animate(
                { scrollTop: r.offset().top + v },
                500
              ),
                c.find(".close-detail").attr("tabindex", "-1");
            }
            return !1;
          }
        }
      ),
        $(document).on(
          "click",
          ".quickbuy-container .close-detail",
          function () {
            var e = $(this).closest(".collection-slider-row");
            return (
              e.length
                ? e
                    .find(".product-block.expanded .quickbuy-toggle:first")
                    .trigger("click")
                : $(this)
                    .closest(".product-block")
                    .find(".quickbuy-toggle:first")
                    .trigger("click"),
              !1
            );
          }
        );
    }),
    $(function () {
      $(document).on("click", ".sharing a", function (e) {
        var t = $(this).parent();
        if (t.hasClass("twitter")) {
          e.preventDefault();
          var i = $(this).attr("href"),
            a = 575,
            o = 450,
            n = ($(window).width() - a) / 2,
            s = ($(window).height() - o) / 2,
            r =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              a +
              ",height=" +
              o +
              ",top=" +
              s +
              ",left=" +
              n;
          window.open(i, "Twitter", r);
        } else if (t.hasClass("facebook")) {
          e.preventDefault();
          var i = $(this).attr("href"),
            a = 626,
            o = 256,
            n = ($(window).width() - a) / 2,
            s = ($(window).height() - o) / 2,
            r =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              a +
              ",height=" +
              o +
              ",top=" +
              s +
              ",left=" +
              n;
          window.open(i, "Facebook", r);
        } else if (t.hasClass("pinterest")) {
          e.preventDefault();
          var i = $(this).attr("href"),
            a = 700,
            o = 550,
            n = ($(window).width() - a) / 2,
            s = ($(window).height() - o) / 2,
            r =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              a +
              ",height=" +
              o +
              ",top=" +
              s +
              ",left=" +
              n;
          window.open(i, "Pinterest", r);
        } else if (t.hasClass("google")) {
          e.preventDefault();
          var i = $(this).attr("href"),
            a = 550,
            o = 450,
            n = ($(window).width() - a) / 2,
            s = ($(window).height() - o) / 2,
            r =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              a +
              ",height=" +
              o +
              ",top=" +
              s +
              ",left=" +
              n;
          window.open(i, "Google+", r);
        }
      });
    }),
    (theme.AnnouncementBarSection = new (function () {
      (this.onSectionLoad = function (e) {
        $(".disclosure", e).each(function () {
          $(this).data("disclosure", new theme.Disclosure($(this)));
        });
      }),
        (this.onSectionUnload = function (e) {
          $(".disclosure", e).each(function () {
            $(this).data("disclosure").unload();
          });
        });
    })()),
    (theme.BlogTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.$container = $(e)),
          this.$container.on(
            "click" + this.namespace,
            ".link-dropdown__button",
            theme.toggleLinkDropdownButton.bind(this)
          ),
          $(document).on("click" + this.namespace, function () {
            $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
          });
      }),
        (this.onSectionUnload = function (e) {
          this.$container.off(this.namespace), $(document).off(this.namespace);
        });
    })()),
    (theme.CartTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.$container = $(e)),
          $(document).on(
            "theme:cartchanged.cartTemplateSection",
            this.functions.refreshCartDependentContent.bind(this)
          ),
          $("#cartform input#terms", e).length > 0 &&
            $(document).on(
              "click.cartTemplateSection",
              '#cartform [name="checkout"], .additional-checkout-buttons input, a[href*="/checkout"]',
              function () {
                if (0 == $("#cartform input#terms:checked").length)
                  return alert(theme.strings.cart_terms_confirmation), !1;
              }
            ),
          $(e).data("ajax-update") &&
            ($(e).on(
              "keyup.cartTemplateSection change.cartTemplateSection changeFromButton.cartTemplateSection",
              ".cart-item__quantity-input",
              function (e) {
                var t;
                this.replacingContent ||
                  ($(e.currentTarget).data("initial-value") &&
                    $(e.currentTarget).data("initial-value") ==
                      $(e.currentTarget).val()) ||
                  0 == $(e.currentTarget).val().length ||
                  "0" == $(e.currentTarget).val() ||
                  ((t =
                    "changeFromButton" === e.type
                      ? $(e.data).attr("id")
                      : $(e.currentTarget).attr("id")),
                  this.functions.updateCart.call(
                    this,
                    {
                      line: $(e.currentTarget).data("line"),
                      quantity: $(e.currentTarget).val(),
                    },
                    function () {
                      $("#" + t).focus();
                    }
                  ));
              }.bind(this)
            ),
            $(e).on(
              "click.cartTemplateSection",
              ".quantity-down, .quantity-up",
              function (e) {
                var t = $(this).closest(".quantity").find("input"),
                  i = t.attr("step") ? parseInt(t.attr("step")) : 1;
                return (
                  $(this).hasClass("quantity-down")
                    ? t
                        .val(parseInt(t.val()) - i)
                        .trigger("changeFromButton", { data: this })
                    : t
                        .val(parseInt(t.val()) + i)
                        .trigger("changeFromButton", { data: this }),
                  !1
                );
              }
            )),
          theme.cartNoteMonitor.load($('.checkout-note [name="note"]', e)),
          $(e).on(
            "click.cartTemplateSection",
            "button[data-toggle-shipping]",
            function () {
              $("#shipping-calculator").toggle();
              var e = $(this).data("toggle-html");
              return (
                $(this).data("toggle-html", $(this).html()), $(this).html(e), !1
              );
            }
          );
      }),
        (this.functions = {
          refreshCartDependentContent: function e() {
            this.cartRefreshXhr && this.cartRefreshXhr.abort(),
              (this.cartRefreshXhr = $.ajax({
                type: "GET",
                url: theme.routes.cart_url,
                success: function (e) {
                  var t = [
                      ".cart-item-list",
                      ".checkout-subtotal-container__right",
                    ],
                    i = $("<div>" + e + "</div>");
                  i.find(".fade-in").removeClass("fade-in"),
                    i.find("[data-cc-animate]").removeAttr("data-cc-animate");
                  for (var a = 0; a < t.length; a++) {
                    this.replacingContent = !0;
                    var o = this.$container.find(t[a]),
                      n = i.find(t[a]);
                    n.find(".cart-item__image").each(function () {
                      var e = o.find("#" + this.id);
                      e.length && $(this).replaceWith(e.clone());
                    }),
                      o.replaceWith(n),
                      (this.replacingContent = !1);
                  }
                }.bind(this),
                error: function e(t) {
                  "abort" != t.statusText &&
                    (console.log("Error refreshing page"), console.log(t));
                },
                complete: function () {
                  this.cartRefreshXhr = null;
                }.bind(this),
              }));
          },
          updateCart: function e(t, i) {
            this.cartXhr && this.cartXhr.abort(),
              this.cartRefreshXhr && this.cartRefreshXhr.abort(),
              (this.cartXhr = $.ajax({
                type: "POST",
                url: theme.routes.cart_change_url + ".js",
                data: t,
                dataType: "json",
                success: function e() {
                  document.documentElement.dispatchEvent(
                    new CustomEvent("theme:cartchanged", {
                      bubbles: !0,
                      cancelable: !1,
                    })
                  ),
                    i();
                },
                error: function e(t) {
                  "abort" != t.statusText &&
                    (console.log("Error processing update"), console.log(t));
                },
                complete: function () {
                  this.cartXhr = null;
                }.bind(this),
              }));
          },
        }),
        (this.onSectionUnload = function (e) {
          $(document).off(".cartTemplateSection"),
            $(e).off(".cartTemplateSection"),
            theme.cartNoteMonitor.unload($('.checkout-note [name="note"]', e));
        });
    })()),
    (theme.CollectionTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.$container = $(e)),
          (this.filterer = new theme.LoadFilterer(this)),
          $(window).on(
            "debouncedresize" + this.namespace,
            this.functions.truncateButtonSubcollections.bind(this)
          ),
          this.functions.truncateButtonSubcollections.call(this);
        var t = $(".subcollection-links--gallery .gallery", e);
        t.on("init", function () {
          $(".lazyload--manual", this)
            .removeClass("lazyload--manual")
            .addClass("lazyload");
        }).slick({
          autoplay: !1,
          fade: !1,
          infinite: !1,
          swipeToSlide: !0,
          slidesToShow: Math.min(
            4,
            $(".subcollection-links--gallery .gallery__item", e).length
          ),
          slidesToScroll: 1,
          useTransform: !0,
          arrows: !0,
          dots: !1,
          prevArrow:
            '<button type="button" class="image-page-button image-page-button--previous" aria-label="' +
            theme.strings.previous +
            '">' +
            theme.icons.chevronLeft +
            "</button>",
          nextArrow:
            '<button type="button" class="image-page-button image-page-button--next" aria-label="' +
            theme.strings.next +
            '">' +
            theme.icons.chevronRight +
            "</button>",
          responsive: [
            {
              breakpoint: 1e3,
              settings: {
                slidesToShow: Math.min(
                  3,
                  $(".subcollection-links--gallery .gallery__item", e).length
                ),
              },
            },
            {
              breakpoint: 768,
              settings:
                "hide" == t.data("mobile-item-count")
                  ? "unslick"
                  : { slidesToShow: t.data("mobile-item-count") },
            },
          ],
        });
      }),
        (this.onSectionUnload = function (e) {
          this.filterer.destroy(),
            $(".subcollection-links__expander", this.$container).off("click"),
            $(".slick-slider", e).slick("unslick").off("init"),
            $(window).off(this.namespace);
        }),
        (this.functions = {
          truncateButtonSubcollections: function e() {
            var t = $(".subcollection-links--buttons", this.$container);
            if ("flex" == t.css("display")) {
              var i = 4,
                a = t.find(".btn");
              a.length > i &&
                0 === t.find(".subcollection-links__expander").length &&
                (a.slice(i - 1).hide(),
                $(
                  '<a href="#" class="btn btn--tertiary subcollection-links__expander">'
                )
                  .text(
                    theme.strings.collections_general_see_all_subcollections
                  )
                  .appendTo(t)
                  .on("click", function (e) {
                    e.preventDefault(),
                      $(this).siblings().show(),
                      $(this).remove();
                  }));
            } else
              t.find(".subcollection-links__expander").length &&
                (t.find(".subcollection-links__expander").siblings().show(),
                t.find(".subcollection-links__expander").remove());
          },
        });
    })()),
    (theme.CustomRowSection = new (function () {
      (this.onSectionLoad = function (e) {
        theme.VideoManager.onSectionLoad(e);
      }),
        (this.onSectionUnload = function (e) {
          theme.VideoManager.onSectionUnload(e);
        });
    })()),
    (theme.FeaturedCollectionSection = new (function () {
      (this.onSectionLoad = function (e) {
        0 === theme.loadCarousels(e).length &&
          theme.ProductBlockManager.loadImages(e);
      }),
        (this.onSectionUnload = function (e) {
          theme.ProductBlockManager.unloadImages(e), theme.unloadCarousels(e);
        });
    })()),
    (theme.FeaturedCollectionsSection = new (function () {
      (this.onSectionLoad = function (e) {
        0 === theme.loadCarousels(e).length &&
          theme.ProductBlockManager.loadImages(e);
      }),
        (this.onSectionUnload = function (e) {
          theme.ProductBlockManager.unloadImages(e), theme.unloadCarousels(e);
        });
    })()),
    (theme.FeaturedProductSection = new (function () {
      (this.onSectionLoad = function (e) {
        theme.initProductGallery(e),
          $(".product-form", e).trigger("load-product-form");
      }),
        (this.onSectionUnload = function (e) {
          theme.destroyProductGallery(e),
            $(".product-form", e).trigger("unload-product-form"),
            $(".slideshow", e).slick("unslick");
        });
    })()),
    (theme.FooterSection = new (function () {
      (this.onSectionLoad = function (e) {
        $(".disclosure", e).each(function () {
          $(this).data("disclosure", new theme.Disclosure($(this)));
        });
      }),
        (this.onSectionUnload = function (e) {
          $(".disclosure", e).each(function () {
            $(this).data("disclosure").unload();
          });
        });
    })()),
    (theme.GallerySection = new (function () {
      (this.onSectionLoad = function (e) {
        var t = $(".gallery--mobile-carousel", e);
        if (t.length) {
          var i = function e() {
            var i = t.hasClass("slick-slider"),
              a = 768 > $(window).width();
            if (
              (a ||
                $(".lazyload--manual", t)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload"),
              i && !a)
            ) {
              t.slick("unslick").off("init"),
                t
                  .find("a, .gallery__item")
                  .removeAttr("tabindex")
                  .removeAttr("role");
              var o = t.data("grid"),
                n = null;
              t.find(".gallery__item").each(function (e) {
                e % o == 0 && (n = $('<div class="gallery__row">').appendTo(t)),
                  $(this).appendTo(n);
              });
            } else
              !i &&
                a &&
                (t.find(".gallery__item").appendTo(t),
                t.find(".gallery__row").remove(),
                t
                  .on("init", function () {
                    $(".lazyload--manual", this)
                      .removeClass("lazyload--manual")
                      .addClass("lazyload");
                  })
                  .slick({
                    autoplay: !1,
                    fade: !1,
                    infinite: !0,
                    useTransform: !0,
                    arrows: !1,
                    dots: !0,
                    customPaging: function e(t, i) {
                      return '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" /><circle class="circle-two" cx="15" cy="15" r="13" /></svg></button>';
                    },
                  }));
          };
          i(), $(window).on("debouncedresize.themeSection" + e.id, i);
        }
        $(".overlay-text__title, .overlay-text__rte", e).each(function () {
          theme.avoidUnecessaryOrphans(this);
        });
      }),
        (this.onSectionUnload = function (e) {
          $(window).off(".themeSection" + e.id),
            $(".slick-slider", e).each(function () {
              $(this).slick("unslick").off("init");
            });
        }),
        (this.onBlockSelect = function (e) {
          var t = $(e).data("slick-index");
          $(e)
            .closest(".slick-slider")
            .each(function () {
              $(this).slick("slickGoTo", t);
            });
        });
    })()),
    (theme.HeaderSection = new (function () {
      (this.onSectionLoad = function (container) {
        $(container).on(
          "focusin.headerSection focusout.headerSection",
          ".social-links",
          function (e) {
            return !1;
          }
        );
        var searchFocusOutTimeoutId = -1;
        $(container).on(
          "focusin.headerSection focusout.headerSection",
          ".search-box",
          function (e) {
            "focusin" == e.type
              ? (clearTimeout(searchFocusOutTimeoutId),
                $(this).closest(".search-box").addClass("focus"))
              : (clearTimeout(searchFocusOutTimeoutId),
                (searchFocusOutTimeoutId = setTimeout(
                  function () {
                    $(this).closest(".search-box").removeClass("focus");
                  }.bind(this),
                  200
                )));
          }
        ),
          $(container).on(
            "click.headerSection",
            ".show-search-link, .main-search__close",
            function (e) {
              return (
                $("body").toggleClass("show-search").hasClass("show-search")
                  ? (setTimeout(function () {
                      $(".main-search__input:first").focus();
                    }, 500),
                    $(".main-search__suggestions .lazyload--manual")
                      .removeClass("lazyload--manual")
                      .addClass("lazyload"))
                  : $(".show-search-link:first").focus(),
                !1
              );
            }
          ),
          $(container).on(
            "keyup.headerSection",
            ".main-search__input",
            function (e) {
              27 == e.keyCode && $(".main-search__close").click();
            }
          );
        var $liveSearchContainer = $(
          '.main-search[data-live-search="true"]',
          container
        );
        if ($liveSearchContainer.length) {
          var searchTimeoutThrottle = 500,
            searchTimeoutID = -1,
            currReqObj = null,
            resultLimit = 8,
            showPrice = $liveSearchContainer.data("live-search-price"),
            showVendor = $liveSearchContainer.data("live-search-vendor"),
            includeMeta = $liveSearchContainer.data("live-search-meta");
          $liveSearchContainer.data("per-row-mob"),
            $(container).on(
              "keyup.headerSection change.headerSection",
              ".main-search__input",
              function () {
                var e = $(".main-search"),
                  t = e.find(".main-search__results"),
                  i = $(this).val();
                if (i.length > 2 && i != $(this).data("oldval")) {
                  $(this).data("oldval", i),
                    null != currReqObj && currReqObj.abort(),
                    clearTimeout(searchTimeoutID);
                  var a = $(this).closest("form"),
                    o =
                      a.attr("action") +
                      (a.attr("action").indexOf("?") > -1 ? "&" : "?") +
                      a.serialize();
                  e
                    .removeClass(
                      "main-search--has-results main-search--results-on-multiple-lines main-search--no-results"
                    )
                    .addClass("main-search--loading"),
                    0 === $(".main-search__results-spinner").length &&
                      t.html(
                        '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>'
                      ),
                    (searchTimeoutID = setTimeout(function () {
                      var n, s;
                      theme.Shopify.features.predictiveSearch
                        ? ((n = theme.routes.predictive_search_url),
                          (s = {
                            q: i,
                            section_id: "predictive-search",
                            resources: {
                              type: a.find('input[name="type"]').val(),
                              limit: resultLimit,
                              options: {
                                unavailable_products: "last",
                                fields: includeMeta
                                  ? "title,product_type,variants.title,vendor,tag,variants.sku"
                                  : "title,product_type,variants.title,vendor",
                              },
                            },
                          }))
                        : ((n = o), (s = { section_id: "main-search" })),
                        (currReqObj = $.ajax({
                          url: n,
                          data: s,
                          dataType: "html",
                          success: function i(a) {
                            var n = null;
                            (n = theme.Shopify.features.predictiveSearch
                              ? $(a).find(".product-list")
                              : $("<div>" + a + "</div>").find(
                                  '[data-section-type="search-template"] .product-list'
                                )),
                              (currReqObj = null),
                              theme.ProductBlockManager.unloadImages(t),
                              e.removeClass(
                                "main-search--has-results main-search--results-on-multiple-lines main-search--no-results"
                              ),
                              t.empty();
                            var s = $(
                                '<div class="main-search__results__products collection-listing"><div></div></div>'
                              ),
                              r = $(
                                '<div class="main-search__results__pages">'
                              );
                            (s.children()[0].className = n[0].className),
                              n
                                .find(
                                  ".product-block:not(.collection-block):not(.page-block)"
                                )
                                .slice(0, resultLimit)
                                .addClass("main-search-result")
                                .each(function () {
                                  $(this).find(".btn.quickbuy-toggle").remove(),
                                    $(this)
                                      .find(".quickbuy-toggle")
                                      .removeClass("quickbuy-toggle"),
                                    showPrice ||
                                      $(this).find(".product-price").remove(),
                                    showVendor ||
                                      $(this).find(".vendor").remove();
                                })
                                .appendTo(s.children()),
                              n
                                .find(".product-block.page-block")
                                .each(function () {
                                  var e = $(
                                    '<a class="main-search-result main-search-result--page">'
                                  ).attr(
                                    "href",
                                    $(this).find("a:first").attr("href")
                                  );
                                  $('<div class="main-search-result__text">')
                                    .text(
                                      $(this).find(".page-block__title").text()
                                    )
                                    .appendTo(e),
                                    r.append(e);
                                }),
                              e.removeClass("main-search--loading");
                            var l =
                                s.find(".main-search-result:first").length > 0,
                              c =
                                r.find(".main-search-result:first").length > 0;
                            l || c
                              ? (e.addClass("main-search--has-results"),
                                e.toggleClass(
                                  "main-search--results-on-multiple-lines",
                                  s.find(".product-block").length > 4
                                ),
                                l &&
                                  (t.append(s),
                                  theme.ProductBlockManager.loadImages(s)),
                                c &&
                                  ($('<h6 class="main-search-result__heading">')
                                    .html(
                                      theme.strings.general_quick_search_pages
                                    )
                                    .prependTo(r),
                                  t.append(r)),
                                $(
                                  '<a class="main-search__results-all-link button altcolour">'
                                )
                                  .attr("href", o)
                                  .html(
                                    theme.strings.layout_live_search_see_all
                                  )
                                  .appendTo(t),
                                theme.initAnimateOnScroll())
                              : (e.addClass("main-search--no-results"),
                                $('<div class="main-search__empty-message">')
                                  .html(
                                    theme.strings
                                      .general_quick_search_no_results
                                  )
                                  .appendTo(t));
                          },
                          error: function e(t) {
                            console.log("Error fetching results");
                          },
                        }));
                    }, searchTimeoutThrottle));
                } else
                  $(this).val().length <= 2 &&
                    ($(this).data("oldval", i),
                    null != currReqObj && currReqObj.abort(),
                    clearTimeout(searchTimeoutID),
                    e.removeClass(
                      "main-search--has-results main-search--results-on-multiple-lines main-search--loading"
                    ),
                    t.empty());
              }
            );
        }
        theme.Navigation.init({
          nav: $(".navigation--main", container),
          proxyTier1Nav: $(".navigation--left", container),
        }),
          theme.inlineNavigationCheck
            ? (theme.inlineNavigationCheck(),
              $(window).on(
                "debouncedresize.headerSection",
                theme.inlineNavigationCheck
              ))
            : document.querySelector("#InlineNavigationCheckScript") &&
              eval(
                document.querySelector("#InlineNavigationCheckScript").innerHTML
              ),
          this.functions.setStickyHeaderHeight.call(this),
          $(window).on(
            "debouncedresize.headerSection",
            this.functions.setStickyHeaderHeight.bind(this)
          ),
          $(".disclosure", container).each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          $(".mobile-navigation-drawer .disclosure").each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
            var e = $(".disclosure-list", this),
              t = 0;
            e.children().each(function () {
              t += $(this).height();
            }),
              $(".disclosure-list", this).css("height", "".concat(t, "px"));
          }),
          $(document).on("theme:cartchanged.headerSection", function () {
            $.get(theme.routes.search_url, function (e) {
              for (
                var t = ["#pageheader .logo-area__right__inner"], i = 0;
                i < t.length;
                i++
              ) {
                var a = $("<div>" + e + "</div>")
                  .find(t[i])
                  .first();
                $(t[i]).html(a.html());
              }
            });
          });
      }),
        (this.onSectionUnload = function (e) {
          $(e).off(".headerSection"),
            $(document).off(".headerSection"),
            $(window).off(".headerSection"),
            $(".disclosure", e).each(function () {
              $(this).data("disclosure").unload();
            }),
            $(".mobile-navigation-drawer .disclosure").each(function () {
              $(this).data("disclosure").unload();
            }),
            theme.Navigation.destroy(
              $(".navigation", e),
              $(".navigation--left", e)
            );
        }),
        (this.functions = {
          setStickyHeaderHeight: function e() {
            var t = document.querySelector(".section-header"),
              i = 0;
            t &&
              ("sticky" === getComputedStyle(t).position ||
                "-webkit-sticky" === getComputedStyle(t).position) &&
              (i = Math.ceil(t.clientHeight)),
              document.documentElement.style.setProperty(
                "--theme-sticky-header-height",
                i + "px"
              );
          },
        });
    })()),
    (theme.ImageWithTextOverlaySection = new (function () {
      var e = this;
      (e.checkForHeaderHeightSubtraction = function () {
        $(
          ".section-image-with-text-overlay .height--full-minus-header-height"
        ).each(function () {
          var e = $(window).height() - $(".section-header").height();
          $(".rimage-outer-wrapper, .placeholder-image", this).height(e);
        });
      }),
        (this.onSectionLoad = function (t) {
          $(".height--full", t).each(function () {
            0 == $(this).closest(".section-image-with-text-overlay").index() &&
              ($(this).addClass("height--full-minus-header-height"),
              e.checkForHeaderHeightSubtraction(),
              $(window)
                .off("debouncedresize.imageWithTextOverlaySection")
                .on(
                  "debouncedresize.imageWithTextOverlaySection",
                  e.checkForHeaderHeightSubtraction
                ));
          }),
            $(".overlay-text__title, .overlay-text__rte", t).each(function () {
              theme.avoidUnecessaryOrphans(this);
            });
        }),
        (this.onSectionUnload = function (e) {
          $(window).off(".imageWithTextOverlaySection");
        });
    })()),
    (theme.ListCollectionsTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        theme.ProductBlockManager.loadImages(e);
      }),
        (this.onSectionUnload = function (e) {
          theme.ProductBlockManager.unloadImages(e);
        });
    })()),
    (theme.ProductTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        $("[data-store-availability-container]", e).length &&
          (this.storeAvailability = new theme.StoreAvailability(
            $("[data-store-availability-container]", e)[0]
          )),
          theme.initProductGallery(e),
          $(".product-form", e).trigger("load-product-form"),
          theme.ProductBlockManager.loadImages(e),
          $(".theme-product-reviews", e).on("click", "a", function () {
            return (
              $("html,body").animate(
                { scrollTop: $($(this).attr("href")).offset().top },
                1e3
              ),
              !1
            );
          });
      }),
        (this.onSectionUnload = function (e) {
          theme.ProductBlockManager.unloadImages(e),
            theme.destroyProductGallery(e),
            $(".product-form", e).trigger("unload-product-form"),
            $(".theme-product-reviews", e).off("click"),
            this.storeAvailability && this.storeAvailability.onSectionUnload();
        });
    })()),
    (theme.SearchTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.$container = $(e)),
          (this.filterer = new theme.LoadFilterer(this));
      }),
        (this.onSectionUnload = function () {
          this.filterer.destroy();
        });
    })()),
    (theme.SlideshowSection = new (function () {
      var e = this;
      (e.checkForHeaderHeightSubtraction = function () {
        $(".section-slideshow .height--full-minus-header-height").each(
          function () {
            var e = $(window).height() - $(".section-header").height();
            $(".rimage-outer-wrapper, .placeholder-image", this).height(e);
          }
        );
      }),
        (this.onSectionLoad = function (t) {
          $(".slideshow", t).each(function () {
            var t = "instant" === $(this).data("transition") ? 0 : 800,
              i = 1e3 * $(this).data("autoplay-speed");
            $(this).find(".height--full").length &&
              0 == $(this).closest(".section-slideshow").index() &&
              ($(this).addClass("height--full-minus-header-height"),
              e.checkForHeaderHeightSubtraction(),
              $(window)
                .off("debouncedresize.slideshowSection")
                .on(
                  "debouncedresize.slideshowSection",
                  e.checkForHeaderHeightSubtraction
                )),
              $(this)
                .on("init", function () {
                  $(".lazyload--manual", this)
                    .removeClass("lazyload--manual")
                    .addClass("lazyload");
                })
                .slick({
                  autoplay: $(this).data("autoplay"),
                  fade: "slide" !== $(this).data("transition"),
                  speed: t,
                  autoplaySpeed: i,
                  arrows: "arrows" === $(this).data("navigation"),
                  dots: "dots" === $(this).data("navigation"),
                  pauseOnHover: !1,
                  infinite: !0,
                  useTransform: !0,
                  prevArrow:
                    '<button type="button" class="slick-prev" aria-label="' +
                    theme.strings.previous +
                    '">' +
                    theme.icons.chevronLeft +
                    "</button>",
                  nextArrow:
                    '<button type="button" class="slick-next" aria-label="' +
                    theme.strings.next +
                    '">' +
                    theme.icons.chevronRight +
                    "</button>",
                  customPaging: function e(a, o) {
                    return (
                      '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" />' +
                      '<circle class="circle-two" cx="15" cy="15" r="13" style="animation-duration: '.concat(
                        i + t,
                        'ms" />'
                      ) +
                      "</svg></button>"
                    );
                  },
                  responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        arrows: !1,
                        dots: "none" !== $(this).data("navigation"),
                      },
                    },
                  ],
                })
                .on("beforeChange", function (e, t, i) {
                  ("slide_fade" === $(this).data("transition") ||
                    "zoom" === $(this).data("transition")) &&
                    $(t.$slides.get(i)).addClass("slick--leaving");
                })
                .on("afterChange", function (e, t) {
                  $(t.$slides)
                    .filter(".slick--leaving")
                    .removeClass("slick--leaving");
                });
          }),
            $(".overlay-text__title, .overlay-text__rte", t).each(function () {
              theme.avoidUnecessaryOrphans(this);
            });
        }),
        (this.onSectionUnload = function (e) {
          $(".slick-slider", e).slick("unslick").off("init"),
            $(window).off(".slideshowSection");
        }),
        (this.onBlockSelect = function (e) {
          $(e)
            .closest(".slick-slider")
            .slick("slickGoTo", $(e).data("slick-index"))
            .slick("slickPause");
        }),
        (this.onBlockDeselect = function (e) {
          $(e).closest(".slick-slider").slick("slickPlay");
        });
    })()),
    (theme.TestimonialsSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.$testimonialContainer = $(".testimonial-list", e)),
          this.$testimonialContainer
            .find(".testimonial-list__inner")
            .on("init", function () {
              $(".lazyload--manual", this)
                .removeClass("lazyload--manual")
                .addClass("lazyload");
            })
            .slick({
              fade: this.$testimonialContainer.hasClass(
                "testimonial-list--with-images"
              ),
              slidesToShow: this.$testimonialContainer.hasClass(
                "testimonial-list--without-images"
              )
                ? 2
                : 1,
              autoplay: this.$testimonialContainer.data("autoplay"),
              autoplaySpeed: this.$testimonialContainer.data("autoplay-speed"),
              dots: !1,
              arrows: !0,
              appendArrows: this.$testimonialContainer.find(
                ".testimonial-list__controls"
              ),
              prevArrow:
                '<button type="button" class="slick-prev" aria-label="' +
                theme.strings.previous +
                '">' +
                theme.icons.chevronLeft +
                "</button>",
              nextArrow:
                '<button type="button" class="slick-next" aria-label="' +
                theme.strings.next +
                '">' +
                theme.icons.chevronRight +
                "</button>",
              responsive: [
                { breakpoint: 768, settings: { fade: !1, slidesToShow: 1 } },
              ],
            });
      }),
        (this.onSectionUnload = function (e) {
          $(".slick-slider", e).each(function () {
            $(this).slick("unslick").off("init");
          });
        }),
        (this.onBlockSelect = function (e) {
          var t = $(e).data("slick-index");
          $(e)
            .closest(".slick-slider")
            .each(function () {
              $(this).slick("slickGoTo", t);
            });
        });
    })()),
    $(function (e) {
      var e = e;
      e(document).on("keyup.themeTabCheck", function (t) {
        9 === t.keyCode &&
          (e("body").addClass("tab-used"),
          e(document).off("keyup.themeTabCheck"));
      }),
        e(document).on("click", "a[data-toggle-target]", function (t) {
          t.preventDefault();
          var i = e(this),
            a = e(e(this).data("toggle-target")),
            o = a.find(".toggle-target-container"),
            n = !a.hasClass("toggle-target--hidden"),
            s =
              a.css("transition-duration").indexOf("ms") >= 0
                ? parseInt(a.css("transition-duration"))
                : 1e3 * parseFloat(a.css("transition-duration"));
          a.hasClass("toggle-target--in-transition") ||
            (n
              ? (i.addClass("toggle-target-toggler--is-hidden"),
                a
                  .addClass(
                    "toggle-target--in-transition toggle-target--hiding"
                  )
                  .css({ height: o.outerHeight() + "px", opacity: 1 }),
                setTimeout(function () {
                  a.css({ height: 0, opacity: 0 }),
                    setTimeout(function () {
                      a
                        .addClass("toggle-target--hidden")
                        .removeClass(
                          "toggle-target--in-transition toggle-target--hiding"
                        ),
                        a.css({ height: "", opacity: "" });
                    }, s);
                }, 10))
              : (i.removeClass("toggle-target-toggler--is-hidden"),
                a
                  .addClass(
                    "toggle-target--in-transition toggle-target--revealing"
                  )
                  .css({ height: 0, opacity: 0, display: "block" }),
                setTimeout(function () {
                  a.css({ height: o.outerHeight() + "px", opacity: 1 }),
                    setTimeout(function () {
                      a.removeClass(
                        "toggle-target--hidden toggle-target--in-transition toggle-target--revealing"
                      ),
                        a.css({ height: "", opacity: "", display: "" });
                    }, s);
                }, 10)));
        }),
        e(document).on("change", "select.navdrop", function () {
          window.location = e(this).val();
        }),
        e(document).on("click", ".mobile-nav-toggle", function (t) {
          t.preventDefault(),
            e("body").hasClass("enable-mobile-nav-transition")
              ? (e("body").removeClass(
                  "reveal-mobile-nav reveal-mobile-nav--revealed"
                ),
                setTimeout(function () {
                  e("body").removeClass("enable-mobile-nav-transition");
                }, 750))
              : (e("body").addClass("enable-mobile-nav-transition"),
                setTimeout(function () {
                  e("body").addClass("reveal-mobile-nav"),
                    e(".mobile-navigation-drawer .disclosure").each(
                      function () {
                        var t = e(".disclosure-list", this),
                          i = 0;
                        t.children().each(function () {
                          i += e(this).height();
                        }),
                          e(".disclosure-list", this).css("height", i + "px");
                      }
                    ),
                    e(".mobile-navigation-drawer .lazyload--manual")
                      .removeClass("lazyload--manual")
                      .addClass("lazyload"),
                    e(".mobile-navigation-drawer .product-list").each(
                      function () {
                        theme.ProductBlockManager.loadImages(e(this));
                      }
                    );
                  var t = e(
                      ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link:first"
                    ).css("transition-delay"),
                    i = e(
                      ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link:first"
                    ).css("transition-duration"),
                    a =
                      parseFloat(t.split(",")[0]) + parseFloat(i.split(",")[0]);
                  setTimeout(function () {
                    e("body").addClass("reveal-mobile-nav--revealed");
                  }, 1e3 * a);
                }, 10));
        }),
        e(
          '<a href="#" class="page-shade" aria-label="' +
            theme.strings.general_navigation_menu_toggle_aria_label +
            '"></a>'
        )
          .on("click", function () {
            return (
              e("body").removeClass("reveal-mobile-nav show-search"),
              setTimeout(function () {
                e("body").removeClass("enable-mobile-nav-transition");
              }, 750),
              !1
            );
          })
          .appendTo("body"),
        "off" != theme.settings.quickbuy_style && theme.loadQuickbuy(),
        e(document).on("load-product-form", ".product-form", function (t) {
          if ("" !== e(this).data("product-id")) {
            var i = e(this),
              a = e(this).closest(".product-detail");
            e(this).on("variantChanged", function (t, i, o) {
              var n = a.find(".product-label-list");
              n.find(".product-label-container").remove(),
                i
                  ? n.append(
                      e("#variant-label-".concat(o.id, "-").concat(i.id)).html()
                    )
                  : n.append(e("#variant-label-".concat(o.id, "-none")).html()),
                i &&
                  a.find(".dynamic-payment-button-template").each(function () {
                    if (
                      (e(this).after(e(this).html()).remove(),
                      Shopify.PaymentButton)
                    ) {
                      var t = null;
                      (t = function e() {
                        document.removeEventListener(
                          "shopify:payment_button:loaded",
                          t
                        ),
                          a
                            .closest(".quickbuy-container")
                            .trigger("changedsize");
                      }),
                        document.addEventListener(
                          "shopify:payment_button:loaded",
                          t
                        ),
                        Shopify.PaymentButton.init();
                    }
                  });
            });
            var o = a.find(".option-selector--swatch");
            o.length &&
              e("body.swatch-style-icon_circle, body.swatch-style-icon_square")
                .length &&
              (o.find(".label").append('<span class="label__value">'),
              e(this).on("variantChanged", function (t, i) {
                o.each(function () {
                  var t = e(this).data("option-index");
                  if (i) {
                    var a = i.options[t];
                    e(this).find(".label__value").text(a);
                  } else {
                    var o = this.querySelector(".opt-btn:checked");
                    o && e(this).find(".label__value").text(o.value);
                  }
                });
              })),
              a.find('.option-selectors[data-disable-unavailable="true"]')
                .length &&
                e(this).on("variantChanged", function (t, i) {
                  var a = this,
                    o = theme.OptionManager.getProductData(e(this)),
                    n = [],
                    s = [];
                  e(
                    '.option-selectors[data-disable-unavailable="true"] .option-selector',
                    this
                  ).each(function (t) {
                    var i = e(this).find("input:checked"),
                      a = e(this).find(
                        '.cc-select__option[aria-selected="true"]'
                      ),
                      o = i.length ? i.val() : a ? a.data("value") : null;
                    s.push(o);
                  });
                  for (var r = 0; r < o.options.length; r++) {
                    for (
                      var l = o.options[r], c = {}, d = 0;
                      d < o.variants.length;
                      d++
                    ) {
                      var h = o.variants[d];
                      c[h.options[r]] || (c[h.options[r]] = !1);
                    }
                    n.push({ name: l, values: c });
                  }
                  for (
                    var u = function e(t) {
                        o.options[t];
                        for (var i = [], a = 0; a < s.length && a < t; a++)
                          i.push(s[a]);
                        Object.keys(n[t].values).forEach((e) => {
                          var a = i.map((e) => e);
                          a.push(e);
                          for (var s = !1, r = 0; r < o.variants.length; r++) {
                            for (
                              var l = o.variants[r], c = !0, d = 0;
                              d < a.length;
                              d++
                            )
                              a[d] && a[d] !== l.options[d] && (c = !1);
                            c && l.available && (s = !0);
                          }
                          n[t].values[e] = s;
                        });
                      },
                      p = 0;
                    p < o.options.length;
                    p++
                  )
                    u(p);
                  for (var m = 0; m < n.length; m++) {
                    var f = function t(i) {
                      e(
                        '.option-selector[data-selector-type="listed"][data-option-index="'.concat(
                          m,
                          '"] .opt-btn'
                        ),
                        a
                      )
                        .filter(function () {
                          return this.value === i;
                        })
                        .toggleClass("is-unavailable", !n[m].values[i]),
                        e(
                          '.option-selector[data-selector-type="dropdown"][data-option-index="'.concat(
                            m,
                            '"] .cc-select__option'
                          ),
                          a
                        )
                          .filter(function () {
                            return this.dataset.value === i;
                          })
                          .toggleClass("is-unavailable", !n[m].values[i]);
                    };
                    for (var g in n[m].values) f(g);
                  }
                  e(this).closest(".quickbuy-container").trigger("changedsize");
                }),
              i.on("change", ".option-selector", function () {
                i.hasClass("product-form--validation-started") &&
                  theme.validateProductForm(i);
              }),
              theme.OptionManager.initProductOptions(e(this));
          }
        }),
        e(document).on("unload-product-form", ".product-form", function () {
          e(this).off("variantChanged change"),
            theme.OptionManager.unloadProductOptions(e(this));
        }),
        e(document).on("variantImageSelected", ".gallery", function (t, i, a) {
          var o = e(this),
            n = o
              .filter(
                ".gallery--layout-columns-1, .gallery--layout-columns-2, .gallery--layout-collage-1, .gallery--layout-collage-2"
              )
              .find(".product-slideshow:not(.slick-slider)"),
            s = !1,
            r = null;
          if ("" !== o.attr("data-variant-image-grouping-option-index")) {
            var l = o.attr("data-variant-image-grouping-option-index"),
              c = i.options[l],
              d = o.find(".thumbnails");
            if ((r = o.find(".slideshow")).hasClass("slick-slider")) {
              var h = !!r.find(
                '.slide[data-media-id="'.concat(i.featured_media.id, '"]')
              ).length;
              r
                .slick("slickUnfilter")
                .slick(
                  "slickFilter",
                  '.slide[data-media-id="'
                    .concat(
                      i.featured_media.id,
                      '"], [data-variant-image-group="'
                    )
                    .concat(c.replace('"', "&quot;").replace(/<>/g, ""), '"]')
                ),
                r.find(".slide").css({
                  position: "",
                  left: "",
                  top: "",
                  zIndex: "",
                  opacity: "",
                }),
                h ||
                  r.slick(
                    "slickGoTo",
                    r
                      .find(
                        '.slide[data-media-id="'.concat(
                          i.featured_media.id,
                          '"]'
                        )
                      )
                      .data("slick-index"),
                    !0
                  );
            }
            if (d.hasClass("owl-carousel")) {
              var u = o.find(".hidden-thumbnails");
              u.length ||
                (u = e('<div class="hidden-thumbnails hidden">').insertAfter(
                  d
                )),
                d
                  .find(".thumbnail")
                  .show()
                  .each(function () {
                    if (
                      e(this).attr("data-variant-image-group") != c &&
                      e(this).attr("data-media-id") != i.featured_media.id
                    ) {
                      var t = e(this).parent().index();
                      e(this).appendTo(u),
                        d.trigger("remove.owl.carousel", [t]);
                    }
                  }),
                u.find(".thumbnail").each(function () {
                  (e(this).attr("data-variant-image-group") == c ||
                    e(this).attr("data-media-id") == i.featured_media.id) &&
                    (e(this).show(), d.trigger("add.owl.carousel", [this]));
                }),
                d.trigger("refresh.owl.carousel");
            } else
              d.find(".thumbnail").each(function () {
                e(this).attr("data-variant-image-group") == c ||
                e(this).attr("data-media-id") == i.featured_media.id
                  ? e(this).show()
                  : e(this).hide();
              });
            n.length &&
              (n.find(".slide").each(function () {
                e(this).attr("data-variant-image-group") == c ||
                e(this).attr("data-media-id") == i.featured_media.id
                  ? (e(this).hasClass("slide--inactive-option") && (s = !0),
                    e(this).removeClass("slide--inactive-option"))
                  : (e(this).hasClass("slide--inactive-option") || (s = !0),
                    e(this).addClass("slide--inactive-option"));
              }),
              n.find(".slide--inactive-option").appendTo(n));
          }
          if (
            (o
              .find(
                '.thumbnails a[data-media-id="' +
                  i.featured_media.id +
                  '"]:first'
              )
              .trigger("select"),
            !a && n.length)
          ) {
            var p = o.find(
              '.slide[data-media-id="' + i.featured_media.id + '"]:first'
            );
            p.length &&
              (s
                ? (o
                    .find(".slide--was-highlighted")
                    .removeClass("slide--was-highlighted"),
                  p.addClass("slide--was-highlighted"))
                : p.hasClass("slide--was-highlighted") ||
                  (clearTimeout(theme.variantImageFadeTimeout),
                  o
                    .find(".slide--highlight-on")
                    .removeClass("slide--highlight-on"),
                  o
                    .find(".slide--highlight-off")
                    .removeClass("slide--highlight-off"),
                  o
                    .find(".slide--was-highlighted")
                    .removeClass("slide--was-highlighted"),
                  p
                    .addClass("slide--highlight-on slide--was-highlighted")
                    .siblings()
                    .addClass("slide--highlight-off"),
                  (theme.variantImageFadeTimeout = setTimeout(function () {
                    o
                      .find(".slide--highlight-on")
                      .removeClass("slide--highlight-on"),
                      o
                        .find(".slide--highlight-off")
                        .removeClass("slide--highlight-off");
                  }, 1200)),
                  theme.scrollToRevealElement(p[0])));
          }
        }),
        e(document).on(
          "click",
          ".product-detail .gallery .main-image a.show-gallery",
          function () {
            var t = [],
              i = e(this)
                .closest(".product-slideshow")
                .find(".slide:not(.slide--inactive-option) .show-gallery"),
              a = e(this).attr("href");
            if (i.length)
              i.each(function () {
                var i = e(this).find(".rimage-outer-wrapper").clone();
                i
                  .find(".lazyloaded")
                  .removeClass("lazyloaded")
                  .addClass("lazyload")
                  .parent()
                  .addClass("lazyload--placeholder"),
                  t.push({ thumbTag: i, zoomUrl: e(this).attr("href") });
              });
            else {
              var o = e(this).find(".rimage-outer-wrapper").clone();
              o
                .find(".lazyloaded")
                .removeClass("lazyloaded")
                .addClass("lazyload")
                .parent()
                .addClass("lazyload--placeholder"),
                t.push({ thumbTag: o, zoomUrl: e(this).attr("href") });
            }
            return (
              theme.buildGalleryViewer({
                images: t,
                currentImage: a,
                prev: theme.icons.chevronLeft,
                next: theme.icons.chevronRight,
                close: theme.icons.close,
              }),
              !1
            );
          }
        );
      var t = e(".product-list, .collection-listing").filter(function () {
        return 0 == e(this).closest("[data-section-type]").length;
      });
      if (
        (t.length && theme.ProductBlockManager.loadImages(t),
        e(window).on("debouncedresize", function () {
          setTimeout(function () {
            theme.ProductBlockManager.afterImagesResized();
          }, 100);
        }),
        e("#template label").each(function () {
          var t = e(this).siblings('input:not([type="submit"]), textarea');
          1 == t.length &&
            t.attr("id").length > 0 &&
            e(this).attr("for", t.attr("id"));
        }),
        e(document).on(
          "click",
          ".quantity-wrapper [data-quantity]",
          function () {
            var t = "up" == e(this).data("quantity") ? 1 : -1,
              i = e(this).closest(".quantity-wrapper").find("[name=quantity]");
            return (
              i.attr("step") && (t *= parseInt(i.attr("step"))),
              i.val(Math.max(1, parseInt(i.val()) + t)).trigger("change"),
              !1
            );
          }
        ),
        e(".responsive-table").on(
          "click",
          ".responsive-table__cell-head",
          function () {
            if (768 > e(window).width())
              return e(this).closest("tr").toggleClass("expanded"), !1;
          }
        ),
        void 0 !== cc && cc.sections)
      )
        for (var i in cc.sections) {
          var a = cc.sections[i];
          if ("video" === a.name) {
            var o = a.section.onSectionLoad;
            a.section.onSectionLoad = function (t) {
              e(".overlay-text__title, .overlay-text__rte", t).each(
                function () {
                  theme.avoidUnecessaryOrphans(this);
                }
              ),
                o.call(this, t);
            };
          }
        }
      theme.Sections.init(),
        theme.Sections.register("slideshow", theme.SlideshowSection),
        theme.Sections.register("gallery", theme.GallerySection),
        theme.Sections.register("testimonials", theme.TestimonialsSection),
        theme.Sections.register(
          "image-with-text-overlay",
          theme.ImageWithTextOverlaySection
        ),
        theme.Sections.register(
          "featured-collection",
          theme.FeaturedCollectionSection
        ),
        theme.Sections.register(
          "featured-collections",
          theme.FeaturedCollectionsSection
        ),
        theme.Sections.register("map", theme.MapSection),
        theme.Sections.register("background-video", theme.VideoManager, {
          deferredLoadViewportExcess: 800,
        }),
        theme.Sections.register("custom-row", theme.CustomRowSection),
        theme.Sections.register(
          "featured-product",
          theme.FeaturedProductSection
        ),
        theme.Sections.register("header", theme.HeaderSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "announcement-bar",
          theme.AnnouncementBarSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register("footer", theme.FooterSection),
        theme.Sections.register("main-product", theme.ProductTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "collection-template",
          theme.CollectionTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register(
          "search-template",
          theme.SearchTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register("blog-template", theme.BlogTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register("cart-template", theme.CartTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "list-collections-template",
          theme.ListCollectionsTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register(
          "page-list-collections-template",
          theme.ListCollectionsTemplateSection,
          { deferredLoad: !1 }
        );
    }),
    $(function (e) {
      cc.sections.length
        ? cc.sections.forEach((e) => {
            try {
              var t = {};
              void 0 !== e.deferredLoad && (t.deferredLoad = e.deferredLoad),
                void 0 !== e.deferredLoadViewportExcess &&
                  (t.deferredLoadViewportExcess = e.deferredLoadViewportExcess),
                theme.Sections.register(e.name, e.section, t);
            } catch (i) {
              console.error(
                "Unable to register section ".concat(e.name, "."),
                i
              );
            }
          })
        : console.warn("Barry: No common sections have been registered.");
    });
})(theme.jQuery);
